// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:54.886Z
// Property: The Preston (ID: 6767906449167339)
// Collections: 29 amenities, 24 floorplans (live), 119 photos, 39 POIs, 8 reviews, 4 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167339",
  "property_external_id": "100160109",
  "property_zillow_url": "https://www.zillow.com/apartments/mcdonough-ga/the-preston/5XhtsL/",
  "property_apartments_url": "https://www.apartments.com/the-preston-mcdonough-ga/530mcpn/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Preston/data=!4m2!3m1!1s0x0:0xa1ca3553a080994e?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "18856143644",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-preston",
  "property_name": "The Preston",
  "property_website_url": "https://www.theprestongaapts.com/",
  "property_domain": "https://www.theprestongaapts.com/",
  "property_address": "100 Preston Creek Dr",
  "property_full_address": "100 Preston Creek Dr, McDonough, GA 30253",
  "property_address_1": "100 Preston Creek Dr",
  "property_address_2": null,
  "property_address_city": "McDonough",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30253",
  "property_address_country": "US",
  "property_address_county": "Henry County",
  "property_neighborhood_address": "Outlying Henry County",
  "property_address_latitude": "33.4349408",
  "property_address_longitude": "-84.1773584",
  "property_email": null,
  "property_phone": "(470) 281-3618",
  "property_call_tracking_phone": "866-705-8370",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "At The Preston in McDonough, GA, elevate your lifestyle with spacious one, two, and three-bedroom apartments featuring modern finishes and serene balconies. Enjoy premier amenities, from a resort-style pool to a state-of-the-art fitness center. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "Welcome to The Preston, your new home in the heart of McDonough, GA! Our stunning apartment community offers a variety of spacious floor plans, including one, two, and three-bedroom options, perfect for individuals, couples, and families alike. Each apartment is thoughtfully designed with modern living in mind, featuring stainless steel appliances, upgraded countertops, in-home washer/dryer, and cozy fireplaces for those chilly evenings.\n\nAt The Preston, we believe that luxury goes beyond just your living space. Our impressive amenities cater to your active lifestyle and foster a sense of community. Stay fit and healthy in our state-of-the-art fitness center or unwind in our tranquil yoga studio. Dive into relaxation at our resort-style swimming pool, complete with grilling stations for perfect summer cookouts. Enjoy movie nights at our theatre room or challenge friends to a match on the volleyball or tennis courts.\n\nSafety and convenience are also prioritized, featuring a gated entrance, courtesy patrol, valet trash program, and garage parking options. Families will appreciate our playground and community kitchen, while our coffee and refreshments bar provides the ideal spot to catch up with neighbors.\n\nExperience the lifestyle you've always dreamed of at The Preston. With unique features like wood-style flooring, comfortable carpeted bedrooms, and private balconies or patios, your new apartment is waiting to welcome you home. \n\nDon't wait any longer—find your new home today! Browse our availability or schedule a tour to explore everything The Preston has to offer. Your perfect apartment in McDonough awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
    "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
    "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
    "width": 2880,
    "height": 1920
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "332",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.96385542168674",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "breed restrictions apply, maximum 2 pets per apartment, up to 75 lb each",
  "property_pet_policy_description": "We welcome cats and dogs (breed restrictions apply), up to 75 lb each. Maximum 2 pets per apartment. One-time pet fee: $300. Monthly pet rent: $20.",
  "property_petpolicy_info": "Pet Policy\nPet Types: Cats & Dogs\nBreed Restrictions Apply\nMax Weight: 75\nMaximum Pets Per Unit: 2\n\nPet Fees\nFee: $300.00\nRent: $20.00",
  "property_online_leasing_url": "https://theprestonaxia.prospectportal.com/Mcdonough/The Preston",
  "property_resident_portal_url": "https://theprestonaxia.residentportal.com/auth",
  "property_apply_now_url": "https://theprestonaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160109/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-7097-761b-b964-ea4e58c918a8.webp",
  "property_primary_logo_media": {
    "alt_text": "The Preston logo.",
    "public_id": "019d5502-7097-761b-b964-ea4e58c918a8",
    "storage_key": "property/6767906449167339/019d5502-7097-761b-b964-ea4e58c918a8.webp",
    "width": 190,
    "height": 114
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d7460-cef4-72e7-9d6c-128c01dfb0b2.webp",
  "property_secondary_logo_media": {
    "alt_text": "Property logo",
    "public_id": "019d7460-cef4-72e7-9d6c-128c01dfb0b2",
    "storage_key": "property/6767906449167339/019d7460-cef4-72e7-9d6c-128c01dfb0b2.webp",
    "width": 1200,
    "height": 1200
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019df43d-7815-7526-9d44-2ede7fd3f2d8.webp",
  "property_fav_icon_media": {
    "alt_text": "Parking icon",
    "public_id": "019df43d-7815-7526-9d44-2ede7fd3f2d8",
    "storage_key": "property/6767906449167339/019df43d-7815-7526-9d44-2ede7fd3f2d8.webp",
    "width": 72,
    "height": 69
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-b0af-703d-941f-00128f16295a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d5502-b0af-703d-941f-00128f16295a",
    "storage_key": "property/6767906449167339/019d5502-b0af-703d-941f-00128f16295a.webp",
    "width": 190,
    "height": 114
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-a46a-7108-b017-78af8a793703.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d5502-a46a-7108-b017-78af8a793703",
    "storage_key": "property/6767906449167339/019d5502-a46a-7108-b017-78af8a793703.webp",
    "width": 190,
    "height": 114
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "767 - 1794",
  "property_sqft_min": "767",
  "property_sqft_max": "1794",
  "property_price_range": "$1459 - $2404",
  "property_price_min": "1459",
  "property_price_max": "2404",
  "property_available_units": 30,
  "property_facebook_url": "https://www.facebook.com/ThePrestonApartments/",
  "property_instagram_url": "https://www.instagram.com/gothepreston/",
  "property_twitter_url": "https://www.facebook.com/ThePrestonApartments/",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9YBlxdJb9IgRTpmAoFM1yqE",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Second+Chance+Apartments&find_loc=McDonough%2C+GA",
  "property_tiktok_url": "https://www.tiktok.com/@lifeatpreston",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Preston",
  "property_home_romance_title": "Experience Love at First Sight in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to The Preston in McDonough, GA, where modern living meets exceptional amenities. Enjoy a state-of-the-art fitness center, unwind by the resort-style pool, or host movie nights in the theatre room. With spacious floor plans and top-notch finishes, your perfect home awaits. Experience unparalleled comfort and community today!",
  "property_home_floorplans_blurb": "At The Preston in McDonough, GA, your dream home awaits. Choose from thoughtfully designed one, two, and three-bedroom floor plans that cater to your unique lifestyle. Each space is crafted to enhance comfort and convenience. Browse our available apartment homes and find the perfect fit for your life today!",
  "property_home_gallery_blurb": "At The Preston in McDonough, GA, luxury meets comfort in an amenity-rich haven. Unwind in our resort-style pool, energize in the state-of-the-art fitness center, or savor a fresh brew at our coffee bar. With spacious floor plans and features like stainless steel appliances, picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to The Preston in McDonough, GA, where comfortable living meets vibrant community life. Choose from thoughtfully designed one, two, or three-bedroom floor plans. Nestled near top schools like Oakland Elementary and Eagle's Landing High, our community is your gateway to enriching experiences. See what's around and uncover local favorites!",
  "property_home_reviews_blurb": "At The Preston in McDonough, GA, residents rave about their vibrant community, highlighting it as “a perfect blend of comfort and convenience.” Join our welcoming atmosphere where friendships flourish and quality living thrives. Curious about life at The Preston? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Welcome to The Preston in McDonough, GA, where family-friendly living meets convenience. Nestled near top educational institutions like Eagle's Landing High School and Tabernacle Christian School, our community offers diverse floor plans to suit your lifestyle. Uncover the local gems that make this neighborhood ideal for all.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Preston in McDonough, GA, elevate your lifestyle with luxurious one, two, and three-bedroom apartments featuring stainless steel appliances and upgraded countertops. Unwind in the resort-style swimming pool or energize at our state-of-the-art fitness center. Enjoy a vibrant community with stunning amenities designed for your comfort and enjoyment!",
  "property_applynow_blurb": "At The Preston in McDonough, GA, your dream home awaits! Choose from stunning one, two, or three-bedroom floor plans, complete with updated amenities like a state-of-the-art fitness center, resort-style pool, and inviting community kitchen. Embrace luxury living—secure your spot and lease online today!",
  "property_contactus_blurb": "At The Preston in McDonough, GA, each thoughtfully designed floor plan—one, two, and three bedrooms—invites you to experience comfort and style. Whether you’re seeking cozy corners or spacious living, our community caters to your every need. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At The Preston in McDonough, GA, we cater to every lifestyle with thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Unlock insights into our vibrant community by visiting our FAQs page and find the answers you need to make The Preston your new home.",
  "property_floorplans_blurb": "At The Preston in McDonough, GA, our thoughtfully designed floor plans cater to every lifestyle, whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven. Browse our available apartment homes and elevate your living experience in a vibrant community that truly feels like home.",
  "property_gallery_blurb": "At The Preston in McDonough, GA, our vibrant community harmonizes modern elegance with comfort. Choose from spacious one, two, or three-bedroom floor plans featuring upgraded amenities. Picture yourself enjoying resort-style living with our state-of-the-art fitness center, inviting swimming pool, and community kitchen—your dream lifestyle awaits!",
  "property_interactivemap_blurb": "At The Preston in McDonough, GA, our charming one, two, and three-bedroom apartments blend comfort with style. Enjoy premium amenities like a resort-style pool, state-of-the-art fitness center, and vibrant community spaces. Use our interactive community map to find your perfect home today and embrace a lifestyle of convenience and luxury!",
  "property_pets_blurb": "At The Preston, we warmly welcome your pets, recognizing that they're essential members of your family. Our pet-friendly apartment community comfortably accommodates up to two pets per apartment, providing ample space and surroundings they’ll love. If you have any specific questions or require further details about our pet amenities and restrictions, our dedicated team is always here to assist you.",
  "property_referafriend_blurb": "At The Preston in McDonough, GA, your ideal home awaits. Choose from one, two, or three-bedroom floor plans designed to elevate your living experience. Share the joy of our vibrant community with friends—great friends make great neighbors. Refer a friend today and enhance your lifestyle together!",
  "property_residentaccess_blurb": "Welcome to The Preston in McDonough, GA, where your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Log into our resident portal for easy rent payments, maintenance requests, and more. Experience convenience and comfort at The Preston—your community hub!",
  "property_reviews_blurb": "At The Preston in McDonough, GA, residents rave about the vibrant community spirit and welcoming atmosphere. One happy tenant shares, \"Living here feels like home!\" Dive into our reviews to see what makes The Preston a favorite among our residents and experience the warmth of our community for yourself!",
  "property_created_at": "1775247669314",
  "property_scheduletour_blurb": "At The Preston in McDonough, GA, find your perfect sanctuary with thoughtfully designed one, two, and three-bedroom floor plans. Experience a thriving community where comfort meets style. Curious about resident experiences? Schedule a tour today and uncover the unique lifestyle waiting for you at The Preston!",
  "property_thankyou_blurb": "Thank you for reaching out to The Preston in McDonough, GA! Our diverse floor plans, including one, two, and three-bedroom options, cater to every lifestyle. A team member will connect with you soon to assist you on your journey toward your new home. We can’t wait to welcome you!",
  "property_virtualtours_blurb": "Welcome to The Preston in McDonough, GA, where comfort meets style. Choose from a variety of spacious floor plans—one, two, or three bedrooms—tailored to your lifestyle. Experience our vibrant community firsthand by taking a virtual tour today and envision your new home at The Preston!",
  "property_copyright": "2026 All Rights Reserved. The Preston",
  "property_seo_title_home": "The Preston |  Apartments in McDonough, GA",
  "property_seo_description_home": "Elevate your lifestyle at The Preston in McDonough, GA! Enjoy amazing floor plans, a resort-style pool, and a fitness center. Make it yours!",
  "property_seo_title_floorplans": "Floor Plans | McDonough, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Preston in McDonough, GA! From cozy one-bedrooms to spacious three-bedrooms, browse unique floor plans tailored for you.",
  "property_seo_title_amenities": "Amenities | McDonough, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at The Preston in McDonough, GA. From a resort-style pool to a state-of-the-art fitness center, your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in McDonough, GA",
  "property_seo_description_gallery": "Experience life at The Preston in McDonough, GA! From stylish apartments to resort-style amenities, picture your perfect home today—photos await!",
  "property_seo_title_virtualtours": "Virtual Tours | The Preston Apartments",
  "property_seo_description_virtualtours": "Step into The Preston in McDonough, GA! Take a virtual tour of our one, two, and three-bedroom apartments, where comfort meets modern living.",
  "property_seo_title_interactivemap": "Interactive Map | The Preston Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Preston in McDonough, GA! Enjoy luxury amenities, from a resort-style pool to a state-of-the-art fitness center. Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in McDonough, GA",
  "property_seo_description_neighborhood": "Uncover the charm of McDonough, GA, around The Preston! Delight in local favorites and hotspots that make your neighborhood feel like home.",
  "property_seo_title_contact": "Contact Us | The Preston",
  "property_seo_description_contact": "Find your perfect home at The Preston in McDonough, GA. From cozy one bedrooms to spacious three bedrooms, our leasing team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in McDonough, GA",
  "property_seo_description_faqs": "Your dream home awaits at The Preston in McDonough, GA! Find answers in our FAQs and learn about our stunning floor plans and luxurious amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in McDonough, GA",
  "property_seo_description_reviews": "Experience life at The Preston in McDonough, GA! Unwind in luxury with top-notch amenities and hear why residents love calling us home. Your oasis awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in McDonough, GA",
  "property_seo_description_applynow": "Experience luxury living at The Preston in McDonough, GA! Choose from 1-3 bedroom layouts with premium amenities like a resort pool, fitness center, and more.",
  "property_seo_title_residentaccess": "Resident Access | The Preston",
  "property_seo_description_residentaccess": "Log in to The Preston resident portal in McDonough, GA. Quickly pay rent, request maintenance, and enjoy hassle-free living at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | The Preston",
  "property_seo_description_referafriend": "Refer a friend to The Preston in McDonough, GA! Great friends make great neighbors—share the joy of our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Preston",
  "property_seo_description_scheduletour": "Experience vibrant living at The Preston in McDonough, GA. Schedule a tour today and envision your future in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | The Preston",
  "property_seo_description_privacy": "At The Preston in McDonough, GA, your privacy matters. Explore our privacy policy to see how we safeguard your personal information!",
  "property_seo_title_accessibility": "Website Accessibility | The Preston",
  "property_seo_description_accessibility": "At The Preston in McDonough, GA, we prioritize digital inclusion. Access our commitment to accessibility and enjoy stress-free living today!",
  "property_seo_title_sitemap": "Sitemap | The Preston",
  "property_seo_description_sitemap": "Uncover your perfect home at The Preston in McDonough, GA. Browse our sitemap for amenities and floor plans that fit your lifestyle. Your new adventure awaits!",
  "property_seo_title_thankyou": "Thank You | The Preston",
  "property_seo_description_thankyou": "Thank you for reaching out to The Preston! We'll be in touch soon to welcome you to your new home in beautiful McDonough, GA. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in McDonough, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793477695",
  "amenities": [
    {
      "id": "custom_c6f48f8f-0bdd-49af-bcde-7feefb8e1889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_371e823b-1ba3-4847-9465-b9c5f69c45a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee/Refreshments Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7df146ca-d4ac-4b45-b1c7-ef1f9744d7d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c52dba67-45a4-49f9-95d3-6e9eba30eb00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Swimming Pool with Grilling Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63ffd86f-282b-4b69-8e65-2a7aafb75209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Community Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_361ea4c8-4ebd-4838-a8e3-1c09eb601c87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7b650b8-5c44-4dca-9c98-1e2bedd50fed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Theatre Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8eb002e5-514a-49d1-9f18-478b937ee3a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Exterior Grilling Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_80249442-cf3b-41af-a6d4-44d20747fdf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_723c3b12-7f63-45f8-b629-09b7286ef8f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Courts",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f06f23c3-3a9b-47a3-a8ed-2b6e2ee40b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Car Care Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_723496f5-224e-406d-a416-56618aadb077",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21b4a961-6fb6-4005-bb6c-ffc96a263c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e45f4e37-557d-4d90-82ae-38e276efacbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c2d7de3-c263-4982-8dff-cec84ae0d1e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e85bbe99-586c-4b9c-9bd5-b0a20a8cca1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Garage Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57bf0f1f-a67e-4a37-8dca-457cd0f6d8e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances with Deep Single Sink",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ce5cbb2-21d4-467d-ae6e-2cde81d6b8fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Countertops",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_473ffd93-4d5c-4627-ab91-b25a80110465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "In‑Home Washer/Dryer",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b23cdeee-5bfa-4922-b017-58a9c4152604",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Garage Parking Available",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f69eebc5-04bb-4e7f-b82f-a3174b203bdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplaces",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae63228c-f2ac-40b8-a105-817ddbec1eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_feffe012-eade-48e7-b9cb-cff6462fec81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40dbc24b-b03f-4c1a-aabf-ad13b6da8e20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9b173f1-50b1-43c0-b9db-317dc48b3761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d45ec28-5c38-4e43-8717-0abdcaa990c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2038807e-edca-4df8-bafc-3ac780e0f745",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01f00f59-6b1f-4f91-b1e3-14c4eb57cf67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e488400-f80a-466e-9fc4-39dcab14f36e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Hook‑Up",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b18cc7eb-59d0-4e7f-84f5-0f9ab02679fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f5-c1a6-774e-a788-10f5fd90c2dd.webp",
      "image_media": {
        "alt_text": "Preston apartment building's leasing office with comfortable seating and a TV at the Preston in McDonough, GA.",
        "public_id": "019e02f5-c1a6-774e-a788-10f5fd90c2dd",
        "storage_key": "property/6767906449167339/019e02f5-c1a6-774e-a788-10f5fd90c2dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the leasing office at Preston, featuring a modern and inviting lounge area with plush seating and entertainment options.",
      "link": "",
      "alt_text": "Preston apartment building's leasing office with comfortable seating and a TV at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_073915b4-08c2-4893-9779-8996cad7cd7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f4-cbc1-73a7-bf13-78a2c45f5ebd.webp",
      "image_media": {
        "alt_text": "Bright and airy business center with comfortable seating and a large conference table at the Preston in McDonough, GA.",
        "public_id": "019e02f4-cbc1-73a7-bf13-78a2c45f5ebd",
        "storage_key": "property/6767906449167339/019e02f4-cbc1-73a7-bf13-78a2c45f5ebd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Collaborate and connect in our modern business center, featuring a spacious conference table, comfortable seating, and ample natural light.",
      "link": "",
      "alt_text": "Bright and airy business center with comfortable seating and a large conference table at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7bcb096f-5210-4ed8-af3c-057c0f502cc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f4-9816-7096-b864-ca032632ad22.webp",
      "image_media": {
        "alt_text": "Stylish modern lobby with seating areas and artwork at the Preston in McDonough, GA.",
        "public_id": "019e02f4-9816-7096-b864-ca032632ad22",
        "storage_key": "property/6767906449167339/019e02f4-9816-7096-b864-ca032632ad22.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our beautifully designed modern lobby, featuring comfortable seating areas and contemporary artwork. A perfect space to relax or meet.",
      "link": "",
      "alt_text": "Stylish modern lobby with seating areas and artwork at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d8c4547-fc66-4a33-beca-5ca6db706355",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f4-99df-704d-b33b-9d4468814459.webp",
      "image_media": {
        "alt_text": "Modern co-working space with a large table, chairs, and laptops.",
        "public_id": "019e02f4-99df-704d-b33b-9d4468814459",
        "storage_key": "property/6767906449167339/019e02f4-99df-704d-b33b-9d4468814459.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A contemporary co-working space featuring a large conference table, comfortable seating, and ample natural light, perfect for residents needing a productive environment.",
      "link": "",
      "alt_text": "Modern co-working space with a large table, chairs, and laptops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_774f16a1-d0c4-4cea-80a7-206a4be73219",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f4-9cf9-72b6-903a-76ba5dae4cba.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a pathway at the Preston in McDonough, GA.",
        "public_id": "019e02f4-9cf9-72b6-903a-76ba5dae4cba",
        "storage_key": "property/6767906449167339/019e02f4-9cf9-72b6-903a-76ba5dae4cba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community. Enjoy the exterior beauty and modern design of our buildings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and a pathway at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_012e16b0-f4b1-45b6-a31c-bcaeb165dff7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f4-99ec-759d-bfd0-30406c617211.webp",
      "image_media": {
        "alt_text": "Reception area with modern seating and front desks at the Preston in McDonough, GA.",
        "public_id": "019e02f4-99ec-759d-bfd0-30406c617211",
        "storage_key": "property/6767906449167339/019e02f4-99ec-759d-bfd0-30406c617211.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our modern reception area, featuring stylish seating and efficient front desks, creating a welcoming atmosphere for all visitors.",
      "link": "",
      "alt_text": "Reception area with modern seating and front desks at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a03c871a-6696-46ef-acf3-497a49c299ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f4-9479-75ec-8874-573015827b8d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawn at the Preston in McDonough, GA.",
        "public_id": "019e02f4-9479-75ec-8874-573015827b8d",
        "storage_key": "property/6767906449167339/019e02f4-9479-75ec-8874-573015827b8d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring private balconies and lush green surroundings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawn at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc09515d-da8d-48ed-b680-9bafae86997a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019e02f3-63a8-7721-81de-b61b4f005b17.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a cabana area at an apartment complex at the Preston in McDonough, GA.",
        "public_id": "019e02f3-63a8-7721-81de-b61b4f005b17",
        "storage_key": "property/6767906449167339/019e02f3-63a8-7721-81de-b61b4f005b17.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style pool, complete with comfortable lounge chairs and a shaded cabana perfect for soaking up the sun or enjoying a cool drink.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a cabana area at an apartment complex at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60a433f6-0a7a-4870-868c-b4dcf9234569",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-42af-70ae-8016-14cc7e35ba96.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, white cabinets, and a subway tile backsplash at the Preston in McDonough, GA.",
        "public_id": "019d797c-42af-70ae-8016-14cc7e35ba96",
        "storage_key": "property/6767906449167339/019d797c-42af-70ae-8016-14cc7e35ba96.webp",
        "width": 2880,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample cabinet storage, and a stylish subway tile backsplash. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances, white cabinets, and a subway tile backsplash at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70c3de02-b7b9-498a-a0e5-5a68cf7004e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-4519-756c-84b4-05489ddb72d1.webp",
      "image_media": {
        "alt_text": "Community wet bar with green tile backsplash and wood shelving at the Preston in McDonough, GA.",
        "public_id": "019d797c-4519-756c-84b4-05489ddb72d1",
        "storage_key": "property/6767906449167339/019d797c-4519-756c-84b4-05489ddb72d1.webp",
        "width": 2880,
        "height": 1920
      },
      "title": "Community",
      "description": "Enjoy refreshments at the community wet bar, featuring a wine fridge, sink, and ample counter space.",
      "link": "",
      "alt_text": "Community wet bar with green tile backsplash and wood shelving at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fa752639-3822-41ef-89d7-edd6bc3b9cee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-47eb-710a-809d-2a6f0c08fa09.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with modern furniture at the Preston in McDonough, GA.",
        "public_id": "019d797c-47eb-710a-809d-2a6f0c08fa09",
        "storage_key": "property/6767906449167339/019d797c-47eb-710a-809d-2a6f0c08fa09.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room and kitchen area featuring a blue sofa, yellow armchairs, and a modern kitchen island with bar stools. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with modern furniture at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf538a5e-d8cf-4f92-9a71-6d51b3cdba32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-437a-7632-9ac6-6e4724b2ec87.webp",
      "image_media": {
        "alt_text": "Lobby area with modern furniture and a fireplace at the Preston in McDonough, GA.",
        "public_id": "019d797c-437a-7632-9ac6-6e4724b2ec87",
        "storage_key": "property/6767906449167339/019d797c-437a-7632-9ac6-6e4724b2ec87.webp",
        "width": 2880,
        "height": 1920
      },
      "title": "Community",
      "description": "Welcome to the spacious and inviting lobby area, featuring comfortable seating, a stylish fireplace, and modern decor. A perfect space to relax or entertain.",
      "link": "",
      "alt_text": "Lobby area with modern furniture and a fireplace at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d1c9c0f-8e5c-4dc5-9af1-0c10130db760",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-48a3-7759-b779-14a04120c313.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at dusk at the Preston in McDonough, GA.",
        "public_id": "019d797c-48a3-7759-b779-14a04120c313",
        "storage_key": "property/6767906449167339/019d797c-48a3-7759-b779-14a04120c313.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and elegant blue umbrellas. The perfect spot to soak up the sun or enjoy a beautiful sunset.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at dusk at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7c762b63-38f5-4c98-a2ad-18aa2f287131",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-3966-712d-9cc4-497e0499a2f9.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with blue and beige siding and balconies under a clear blue sky at the Preston in McDonough, GA.",
        "public_id": "019d797c-3966-712d-9cc4-497e0499a2f9",
        "storage_key": "property/6767906449167339/019d797c-3966-712d-9cc4-497e0499a2f9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Beautiful apartment buildings featuring charming balconies and lush green landscaping. Experience comfortable living in this scenic community.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with blue and beige siding and balconies under a clear blue sky at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cec2af1a-f5a1-4f7b-8e7e-6e4047c88c97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-3d96-736e-9942-d4c2e9089fc6.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with dark blue siding and beige accents, featuring balconies and manicured lawn at the Preston in McDonough, GA.",
        "public_id": "019d797c-3d96-736e-9942-d4c2e9089fc6",
        "storage_key": "property/6767906449167339/019d797c-3d96-736e-9942-d4c2e9089fc6.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Showcasing the impressive exterior of our apartment complex, complete with beautiful landscaping and spacious balconies.",
      "link": "",
      "alt_text": "Exterior of a multi-story apartment building with dark blue siding and beige accents, featuring balconies and manicured lawn at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8d69417-aa96-4a45-a1f2-8813ea0a4ca0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-34cb-77f9-8a4a-af410eca2300.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
        "public_id": "019d797c-34cb-77f9-8a4a-af410eca2300",
        "storage_key": "property/6767906449167339/019d797c-34cb-77f9-8a4a-af410eca2300.webp",
        "width": 2880,
        "height": 1920
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with spacious balconies, surrounded by lush green lawns and mature trees. Enjoy comfortable living in this stunning community.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d41ea2d6-9167-4f4d-ae5a-971e4fad852b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-3b25-73e0-9b9b-1746e401ad69.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with dark blue and tan siding, balconies, and lush landscaping at the Preston in McDonough, GA.",
        "public_id": "019d797c-3b25-73e0-9b9b-1746e401ad69",
        "storage_key": "property/6767906449167339/019d797c-3b25-73e0-9b9b-1746e401ad69.webp",
        "width": 1465,
        "height": 1024
      },
      "title": "Community",
      "description": "Spacious apartments set within a beautifully landscaped community. Enjoy the convenience of your private balcony and the vibrant green surroundings.",
      "link": "",
      "alt_text": "Exterior of a multi-story apartment building with dark blue and tan siding, balconies, and lush landscaping at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da75ae28-faec-4097-ba5c-a1fbd088157f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-3901-7243-b0c0-ae036c59a780.webp",
      "image_media": {
        "alt_text": "Exterior of a large apartment building with dark blue and tan siding, stone accents, and white balconies under a clear blue sky at the Preston in McDonough, GA.",
        "public_id": "019d797c-3901-7243-b0c0-ae036c59a780",
        "storage_key": "property/6767906449167339/019d797c-3901-7243-b0c0-ae036c59a780.webp",
        "width": 860,
        "height": 573
      },
      "title": "Community",
      "description": "Beautifully appointed apartment building exterior featuring a mix of dark blue and tan siding, accented with natural stone and elegant white balconies.",
      "link": "",
      "alt_text": "Exterior of a large apartment building with dark blue and tan siding, stone accents, and white balconies under a clear blue sky at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5893619e-a638-4f96-9670-bf81c4787725",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-37c3-712d-84ab-36699030d9df.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with balconies and landscaping at the Preston in McDonough, GA.",
        "public_id": "019d797c-37c3-712d-84ab-36699030d9df",
        "storage_key": "property/6767906449167339/019d797c-37c3-712d-84ab-36699030d9df.webp",
        "width": 850,
        "height": 594
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring multiple balconies and lush green landscaping under a clear blue sky.",
      "link": "",
      "alt_text": "Exterior of an apartment building with balconies and landscaping at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10e9676b-e80f-4f5c-82f9-de84e10eb9eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-22c8-740c-9cc2-6bd7fb1cdc67.webp",
      "image_media": {
        "alt_text": "Spacious living room with light beige walls, wood-look flooring, and a ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797c-22c8-740c-9cc2-6bd7fb1cdc67",
        "storage_key": "property/6767906449167339/019d797c-22c8-740c-9cc2-6bd7fb1cdc67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy ample natural light and a comfortable atmosphere in this beautifully appointed living space. Features wood-look flooring and a modern ceiling fan.",
      "link": "",
      "alt_text": "Spacious living room with light beige walls, wood-look flooring, and a ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3286a4b9-4449-4fa0-bb42-fa10c5b8b224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-3224-716d-adcb-550f487b0c19.webp",
      "image_media": {
        "alt_text": "Exterior view of multi-unit apartment building with attached garages at the Preston in McDonough, GA.",
        "public_id": "019d797c-3224-716d-adcb-550f487b0c19",
        "storage_key": "property/6767906449167339/019d797c-3224-716d-adcb-550f487b0c19.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Charming multi-unit apartment building featuring attached garages and tasteful exterior design.",
      "link": "",
      "alt_text": "Exterior view of multi-unit apartment building with attached garages at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3cf20850-8fb2-4166-8a7c-0ef3cfe71515",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-3465-75e3-b3c9-c6ad90225284.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies under a clear blue sky.",
        "public_id": "019d797c-3465-75e3-b3c9-c6ad90225284",
        "storage_key": "property/6767906449167339/019d797c-3465-75e3-b3c9-c6ad90225284.webp",
        "width": 876,
        "height": 584
      },
      "title": "Community",
      "description": "Stunning exterior view of modern apartment buildings featuring spacious balconies and well-maintained landscaping, creating an inviting community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51228da7-ecc3-49ab-9e7c-3ab6fcfd56f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-1eba-704b-ae4c-36099ffd2518.webp",
      "image_media": {
        "alt_text": "Spacious living room with a view of the kitchen at the Preston in McDonough, GA.",
        "public_id": "019d797c-1eba-704b-ae4c-36099ffd2518",
        "storage_key": "property/6767906449167339/019d797c-1eba-704b-ae4c-36099ffd2518.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space with modern finishes. The kitchen features a breakfast bar, perfect for casual dining.",
      "link": "",
      "alt_text": "Spacious living room with a view of the kitchen at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8aec528-35ef-4bc4-92ec-2ba86f530e65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-21e3-74fc-a7ee-62bac80f1ab1.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washer and dryer and shelving at the Preston in McDonough, GA.",
        "public_id": "019d797c-21e3-74fc-a7ee-62bac80f1ab1",
        "storage_key": "property/6767906449167339/019d797c-21e3-74fc-a7ee-62bac80f1ab1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with ample shelving for storage.",
      "link": "",
      "alt_text": "Laundry room with stacked washer and dryer and shelving at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c9e62bd-f442-42b1-b599-e3e6188f4557",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-1e15-70b3-bc37-a0a294d6544d.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and stone accents at the Preston in McDonough, GA.",
        "public_id": "019d797c-1e15-70b3-bc37-a0a294d6544d",
        "storage_key": "property/6767906449167339/019d797c-1e15-70b3-bc37-a0a294d6544d.webp",
        "width": 2808,
        "height": 1872
      },
      "title": "Community",
      "description": "Beautiful apartment building exterior featuring balconies, stone accents, and lush green surroundings.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and stone accents at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25a41473-5dff-4bf4-a10d-155379577312",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-16cc-715d-8ac6-20788e211007.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, stainless steel sink, and chrome faucet, opening into living area.",
        "public_id": "019d797c-16cc-715d-8ac6-20788e211007",
        "storage_key": "property/6767906449167339/019d797c-16cc-715d-8ac6-20788e211007.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover the stylish and functional kitchen in our apartments, featuring sleek white countertops and a deep stainless steel sink. Perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white countertops, stainless steel sink, and chrome faucet, opening into living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_870d3b16-f792-4b8c-ad86-49024efa5e35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-177f-739d-9c89-bbab241cefb0.webp",
      "image_media": {
        "alt_text": "Living room with sofas, coffee table, TV, and ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797c-177f-739d-9c89-bbab241cefb0",
        "storage_key": "property/6767906449167339/019d797c-177f-739d-9c89-bbab241cefb0.webp",
        "width": 2644,
        "height": 1799
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living room featuring comfortable sofas, a wooden coffee table, a large flat-screen TV, and a ceiling fan.",
      "link": "",
      "alt_text": "Living room with sofas, coffee table, TV, and ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_215a7823-13b1-4d07-ae45-e1ea14b9771e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-1916-762a-b0f6-ca4854f854b0.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, coffee table, and a bookshelf filled with books at the Preston in McDonough, GA.",
        "public_id": "019d797c-1916-762a-b0f6-ca4854f854b0",
        "storage_key": "property/6767906449167339/019d797c-1916-762a-b0f6-ca4854f854b0.webp",
        "width": 2790,
        "height": 1835
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring a comfortable sectional sofa, a stylish coffee table, and a decorative bookshelf, perfect for any resident.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, coffee table, and a bookshelf filled with books at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d1a388d-9fdf-403a-a5b2-981089f365e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-277e-72dc-96f5-4f21c3af3382.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with garages and blue accents at the Preston in McDonough, GA.",
        "public_id": "019d797c-277e-72dc-96f5-4f21c3af3382",
        "storage_key": "property/6767906449167339/019d797c-277e-72dc-96f5-4f21c3af3382.webp",
        "width": 845,
        "height": 563
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring attached garages and stylish blue and tan siding.",
      "link": "",
      "alt_text": "Exterior of apartment building with garages and blue accents at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2eb4f31f-214f-4b53-aa54-9371fe2a57cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-2052-7666-9bbd-907beb6a082e.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797c-2052-7666-9bbd-907beb6a082e",
        "storage_key": "property/6767906449167339/019d797c-2052-7666-9bbd-907beb6a082e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly designed bedroom featuring a comfortable king-size bed, modern nightstands, and a ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5edcd6bf-2e2c-4300-bc9e-6169b157aaf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797c-11ed-74da-869d-bae61e964eef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at the Preston in McDonough, GA.",
        "public_id": "019d797c-11ed-74da-869d-bae61e964eef",
        "storage_key": "property/6767906449167339/019d797c-11ed-74da-869d-bae61e964eef.webp",
        "width": 2352,
        "height": 2082
      },
      "title": "Apartment",
      "description": "A stylish kitchen featuring stainless steel appliances, a sleek microwave, and ample white cabinetry. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a885febf-891f-4943-a279-7a0ecc661313",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fa73-739d-b3eb-88adde4163ef.webp",
      "image_media": {
        "alt_text": "Bedroom with neutral carpet, blinds, and ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797b-fa73-739d-b3eb-88adde4163ef",
        "storage_key": "property/6767906449167339/019d797b-fa73-739d-b3eb-88adde4163ef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush neutral carpeting, a ceiling fan, and large blinds for natural light. Includes access to a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with neutral carpet, blinds, and ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_449a881a-5dd4-410e-8758-7e63c1e35606",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fb7e-735d-b4ea-1f1c1b22cabf.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, TV, closet, and window at the Preston in McDonough, GA.",
        "public_id": "019d797b-fb7e-735d-b4ea-1f1c1b22cabf",
        "storage_key": "property/6767906449167339/019d797b-fb7e-735d-b4ea-1f1c1b22cabf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush bed, modern dresser, entertainment center, and ample closet space. A large window provides natural light.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, TV, closet, and window at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cb0d3d7-52d0-4e94-8c0f-c9981a6b6ed0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fabf-70a7-8ba0-48a0eac111fb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops at the Preston in McDonough, GA.",
        "public_id": "019d797b-fabf-70a7-8ba0-48a0eac111fb",
        "storage_key": "property/6767906449167339/019d797b-fabf-70a7-8ba0-48a0eac111fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, and a spacious island with a sink and faucet. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_600c4088-3afe-4694-b981-41e36e7b7f50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-f6e8-7598-8247-219267e3a5a6.webp",
      "image_media": {
        "alt_text": "Spacious living room with a view of the kitchen, featuring light wood floors and a ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797b-f6e8-7598-8247-219267e3a5a6",
        "storage_key": "property/6767906449167339/019d797b-f6e8-7598-8247-219267e3a5a6.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this open-concept living space, seamlessly connected to a modern kitchen. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Spacious living room with a view of the kitchen, featuring light wood floors and a ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c529cf2-d601-4163-a074-fe11e628bcda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fc09-755f-837e-e72554a0a580.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with white tile surround at the Preston in McDonough, GA.",
        "public_id": "019d797b-fc09-755f-837e-e72554a0a580",
        "storage_key": "property/6767906449167339/019d797b-fc09-755f-837e-e72554a0a580.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek vanity with a quartz countertop, a clean white toilet, and a relaxing bathtub with a white tiled shower surround.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with white tile surround at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7298cfa7-cb27-4d39-868a-5a44d0a9dafd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-f862-777a-9563-15af384d13c0.webp",
      "image_media": {
        "alt_text": "In-unit laundry room with washer, dryer and shelving at the Preston in McDonough, GA.",
        "public_id": "019d797b-f862-777a-9563-15af384d13c0",
        "storage_key": "property/6767906449167339/019d797b-f862-777a-9563-15af384d13c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with overhead shelving for all your laundry needs.",
      "link": "",
      "alt_text": "In-unit laundry room with washer, dryer and shelving at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51eba66c-cbe4-4c92-a610-b0afd0ca86d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fb7f-72e9-9214-4c87be9cc34b.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and open door to hallway at the Preston in McDonough, GA.",
        "public_id": "019d797b-fb7f-72e9-9214-4c87be9cc34b",
        "storage_key": "property/6767906449167339/019d797b-fb7f-72e9-9214-4c87be9cc34b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, and access to a hallway through a white paneled door.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and open door to hallway at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14282197-8a02-406b-8627-dfe4e46eeda0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-f74d-747b-93c4-dd19e4b4dc54.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with stainless steel appliances and island at the Preston in McDonough, GA.",
        "public_id": "019d797b-f74d-747b-93c4-dd19e4b4dc54",
        "storage_key": "property/6767906449167339/019d797b-f74d-747b-93c4-dd19e4b4dc54.webp",
        "width": 2900,
        "height": 2099
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly flows into a modern kitchen, featuring a large island, sleek cabinetry, and stainless steel appliances.",
      "link": "",
      "alt_text": "Open concept living area and kitchen with stainless steel appliances and island at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ccd933e-047f-4e8f-9226-a85b5c16e8a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-fb05-7009-ab4d-13d3bd0e6c48.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving at the Preston in McDonough, GA at the Preston in McDonough, GA.",
        "public_id": "019d797b-fb05-7009-ab4d-13d3bd0e6c48",
        "storage_key": "property/6767906449167339/019d797b-fb05-7009-ab4d-13d3bd0e6c48.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving at the Preston in McDonough, GA at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16f4f095-912c-484b-ab39-8a5d7ddaa9e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-f059-759a-83ff-e00a58ccc99a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, dishwasher, and sink with chrome faucet.",
        "public_id": "019d797b-f059-759a-83ff-e00a58ccc99a",
        "storage_key": "property/6767906449167339/019d797b-f059-759a-83ff-e00a58ccc99a.webp",
        "width": 2785,
        "height": 2400
      },
      "title": "Apartment",
      "description": "Discover the sleek design of our kitchens, featuring stainless steel appliances including a refrigerator, dishwasher, and a deep sink with a modern chrome faucet.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, dishwasher, and sink with chrome faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db540e51-08c9-4dbb-85b9-67e4e3aa13bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-bee9-7249-b779-fd523d474591.webp",
      "image_media": {
        "alt_text": "Spacious living area with a modern kitchen island, featuring wood-look flooring and natural light at the Preston in McDonough, GA.",
        "public_id": "019d797b-bee9-7249-b779-fd523d474591",
        "storage_key": "property/6767906449167339/019d797b-bee9-7249-b779-fd523d474591.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment, boasting a contemporary kitchen island and an open-concept living area flooded with natural light.",
      "link": "",
      "alt_text": "Spacious living area with a modern kitchen island, featuring wood-look flooring and natural light at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8671d63b-d294-4be4-8033-84a52bdadbd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-b9ef-700b-b347-fdc5a9fd2d82.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island at the Preston in McDonough, GA.",
        "public_id": "019d797b-b9ef-700b-b347-fdc5a9fd2d82",
        "storage_key": "property/6767906449167339/019d797b-b9ef-700b-b347-fdc5a9fd2d82.webp",
        "width": 2218,
        "height": 1917
      },
      "title": "Apartment",
      "description": "A beautifully appointed kitchen featuring stainless steel appliances, ample cabinet space, and a spacious island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57a46528-281b-4336-a156-7ce6cf5b3705",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-bb36-74b9-a3d7-06ec059d61b4.webp",
      "image_media": {
        "alt_text": "Living room with navy blue sofa and armchair, coffee table, and TV at the Preston in McDonough, GA.",
        "public_id": "019d797b-bb36-74b9-a3d7-06ec059d61b4",
        "storage_key": "property/6767906449167339/019d797b-bb36-74b9-a3d7-06ec059d61b4.webp",
        "width": 1666,
        "height": 1144
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy navy blue sofa and armchair, perfect for relaxation. Enjoy entertainment on the wall-mounted TV, and admire the modern decor.",
      "link": "",
      "alt_text": "Living room with navy blue sofa and armchair, coffee table, and TV at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ac6f99e-f73e-464a-a57b-a978728baea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-ba68-730f-9af2-34727d727cd5.webp",
      "image_media": {
        "alt_text": "Living room with a large sectional sofa, coffee table, ottoman, and TV.",
        "public_id": "019d797b-ba68-730f-9af2-34727d727cd5",
        "storage_key": "property/6767906449167339/019d797b-ba68-730f-9af2-34727d727cd5.webp",
        "width": 1920,
        "height": 1455
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a stylish coffee table, and a large television, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a large sectional sofa, coffee table, ottoman, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_524d12a7-ae80-4c7c-8d51-4a3e8dc4c64d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-b766-71e6-bc15-2c034f323abd.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, yellow accent chairs, dining table, and TV at the Preston in McDonough, GA.",
        "public_id": "019d797b-b766-71e6-bc15-2c034f323abd",
        "storage_key": "property/6767906449167339/019d797b-b766-71e6-bc15-2c034f323abd.webp",
        "width": 1932,
        "height": 1232
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa, vibrant yellow accent chairs, a dining area, and a wall-mounted TV, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with blue sofa, yellow accent chairs, dining table, and TV at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2232c1d8-84db-494c-8112-c1db54686e7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-8aab-72b3-ae70-667f0e96c616.webp",
      "image_media": {
        "alt_text": "Bedroom with two doors leading to a bathroom and a closet at the Preston in McDonough, GA.",
        "public_id": "019d797b-8aab-72b3-ae70-667f0e96c616",
        "storage_key": "property/6767906449167339/019d797b-8aab-72b3-ae70-667f0e96c616.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and access to a bathroom and a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with two doors leading to a bathroom and a closet at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdea397d-7530-4f7c-935c-fe2e2d009baf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-a4b7-747f-a221-19d1da8cdb8d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a breakfast bar at the Preston in McDonough, GA.",
        "public_id": "019d797b-a4b7-747f-a221-19d1da8cdb8d",
        "storage_key": "property/6767906449167339/019d797b-a4b7-747f-a221-19d1da8cdb8d.webp",
        "width": 3072,
        "height": 1950
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring stainless steel appliances, ample cabinet space, and a convenient breakfast bar, perfect for a quick meal or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and a breakfast bar at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6cbe333-6c93-4f93-bb1c-76a4e8e0cd67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-8926-7464-8d32-702f622c9e3e.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving at the Preston in McDonough, GA.",
        "public_id": "019d797b-8926-7464-8d32-702f622c9e3e",
        "storage_key": "property/6767906449167339/019d797b-8926-7464-8d32-702f622c9e3e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fcb78d4a-3044-4d2f-956a-4d043d78813d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-a279-701f-8369-f5e3a0af0ba1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a marble countertop at the Preston in McDonough, GA.",
        "public_id": "019d797b-a279-701f-8369-f5e3a0af0ba1",
        "storage_key": "property/6767906449167339/019d797b-a279-701f-8369-f5e3a0af0ba1.webp",
        "width": 2693,
        "height": 2135
      },
      "title": "Apartment",
      "description": "Enjoy this beautifully updated bathroom featuring a clean white bathtub, a sleek toilet, and a modern vanity with a marble countertop.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a marble countertop at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eac708ff-06c4-46cb-b43c-573f2e2b2fcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-7b0f-76ff-a1d4-5021eefc01dc.webp",
      "image_media": {
        "alt_text": "Spacious fitness center with treadmills, ellipticals, and weight machines at the Preston in McDonough, GA.",
        "public_id": "019d797b-7b0f-76ff-a1d4-5021eefc01dc",
        "storage_key": "property/6767906449167339/019d797b-7b0f-76ff-a1d4-5021eefc01dc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring a variety of cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Spacious fitness center with treadmills, ellipticals, and weight machines at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d8378e4-7e08-44c9-a168-4c3539e36a88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-9f5e-71e4-b748-1ee8dd8e36d6.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub at the Preston in McDonough, GA.",
        "public_id": "019d797b-9f5e-71e4-b748-1ee8dd8e36d6",
        "storage_key": "property/6767906449167339/019d797b-9f5e-71e4-b748-1ee8dd8e36d6.webp",
        "width": 2693,
        "height": 2135
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a vanity with a quartz countertop and a chrome faucet, a toilet, and a bathtub with tiled walls.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_216594e1-03e7-4dce-af2d-fa0de35745f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-845d-70d3-9908-0739551117a6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, and weight machines.",
        "public_id": "019d797b-845d-70d3-9908-0739551117a6",
        "storage_key": "property/6767906449167339/019d797b-845d-70d3-9908-0739551117a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2aea9ff4-f0fc-47a8-9909-317549012f5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-6a2b-71b9-89e1-e19934e92cdb.webp",
      "image_media": {
        "alt_text": "Sand volleyball court with net and apartment buildings in the background at the Preston in McDonough, GA.",
        "public_id": "019d797b-6a2b-71b9-89e1-e19934e92cdb",
        "storage_key": "property/6767906449167339/019d797b-6a2b-71b9-89e1-e19934e92cdb.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a game of sand volleyball at our community's court, surrounded by lush greenery and convenient apartment living.",
      "link": "",
      "alt_text": "Sand volleyball court with net and apartment buildings in the background at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce2ab245-426b-40a3-beb3-91ee0352e184",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-7854-7098-abe6-cb60f7a30346.webp",
      "image_media": {
        "alt_text": "Community lounge area with foosball table, fireplace, and kitchen island at the Preston in McDonough, GA.",
        "public_id": "019d797b-7854-7098-abe6-cb60f7a30346",
        "storage_key": "property/6767906449167339/019d797b-7854-7098-abe6-cb60f7a30346.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy entertaining friends in our spacious community lounge, featuring a foosball table, cozy fireplace, and a full kitchen island.",
      "link": "",
      "alt_text": "Community lounge area with foosball table, fireplace, and kitchen island at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9355359b-1af5-405c-aab6-64cb9fd87909",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-6b84-7011-8c9b-a4a0e95f8ee7.webp",
      "image_media": {
        "alt_text": "Community business center with computer, printer, and seating at the Preston in McDonough, GA.",
        "public_id": "019d797b-6b84-7011-8c9b-a4a0e95f8ee7",
        "storage_key": "property/6767906449167339/019d797b-6b84-7011-8c9b-a4a0e95f8ee7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Utilize the convenient business center, equipped with computers and a printer, perfect for catching up on work or printing important documents.",
      "link": "",
      "alt_text": "Community business center with computer, printer, and seating at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a9f21928-25e9-457f-b4eb-b48af142f428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-8968-72a9-bf3f-455d1aac5b87.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, blinds, and a walk-in closet at the Preston in McDonough, GA.",
        "public_id": "019d797b-8968-72a9-bf3f-455d1aac5b87",
        "storage_key": "property/6767906449167339/019d797b-8968-72a9-bf3f-455d1aac5b87.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, blinds for natural light, and a convenient walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, blinds, and a walk-in closet at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b74bccc-c6bc-4ff1-a3cd-ffdfbb70892f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-4af4-711d-913c-ebfd323f8aed.webp",
      "image_media": {
        "alt_text": "Tennis court with lush green trees and blue sky at the Preston in McDonough, GA.",
        "public_id": "019d797b-4af4-711d-913c-ebfd323f8aed",
        "storage_key": "property/6767906449167339/019d797b-4af4-711d-913c-ebfd323f8aed.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our full-size tennis court, surrounded by beautiful landscaping.",
      "link": "",
      "alt_text": "Tennis court with lush green trees and blue sky at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e1a8b47-33e2-4fd4-b618-a1ef1d53460b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-8afe-7183-b8e6-e440cecced2a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and toilet. Tub and shower visible in mirror reflection at the Preston in McDonough, GA.",
        "public_id": "019d797b-8afe-7183-b8e6-e440cecced2a",
        "storage_key": "property/6767906449167339/019d797b-8afe-7183-b8e6-e440cecced2a.webp",
        "width": 2601,
        "height": 2400
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity with a white sink and quartz countertop, a large mirror reflecting the tub and shower, and a toilet. The bathroom is well-lit and includes a towel rack.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and toilet. Tub and shower visible in mirror reflection at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68889ba5-afe4-4010-84a7-7d2625975276",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-7044-744c-9361-25e49d965378.webp",
      "image_media": {
        "alt_text": "Shuffleboard table and lounge area with fireplace in a community common room at the Preston in McDonough, GA.",
        "public_id": "019d797b-7044-744c-9361-25e49d965378",
        "storage_key": "property/6767906449167339/019d797b-7044-744c-9361-25e49d965378.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of shuffleboard or relax by the fireplace in this spacious community lounge area, perfect for socializing and recreation.",
      "link": "",
      "alt_text": "Shuffleboard table and lounge area with fireplace in a community common room at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd968bdf-72e2-46fc-a3bc-c94e82a6f8cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-680f-70e0-914d-65ddea6c4abf.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with comfortable seating, a fireplace, and a bar at the Preston in McDonough, GA.",
        "public_id": "019d797b-680f-70e0-914d-65ddea6c4abf",
        "storage_key": "property/6767906449167339/019d797b-680f-70e0-914d-65ddea6c4abf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring plush seating, a cozy fireplace, and a modern bar area perfect for gatherings.",
      "link": "",
      "alt_text": "Spacious community lounge area with comfortable seating, a fireplace, and a bar at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31ad83ac-8ea2-438f-839b-42e319e57647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-66dc-765d-8a1c-86029165a278.webp",
      "image_media": {
        "alt_text": "Dining area with a large wooden table and chairs, a buffet with decorative items, and a teal accent wall with mirrors at the Preston in McDonough, GA.",
        "public_id": "019d797b-66dc-765d-8a1c-86029165a278",
        "storage_key": "property/6767906449167339/019d797b-66dc-765d-8a1c-86029165a278.webp",
        "width": 3072,
        "height": 1604
      },
      "title": "Community",
      "description": "Gather in the elegant dining area, perfect for hosting friends or enjoying a meal with neighbors. This community space offers a stylish setting for any occasion.",
      "link": "",
      "alt_text": "Dining area with a large wooden table and chairs, a buffet with decorative items, and a teal accent wall with mirrors at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a05491ca-37e6-431d-878f-29277890f150",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-3584-7509-a1aa-1f7b657f6eca.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees surrounding the property at the Preston in McDonough, GA.",
        "public_id": "019d797b-3584-7509-a1aa-1f7b657f6eca",
        "storage_key": "property/6767906449167339/019d797b-3584-7509-a1aa-1f7b657f6eca.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees surrounding the property at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd6c628e-a141-422f-b290-b87948894a8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-30f2-7239-b189-7f8afd84bb66.webp",
      "image_media": {
        "alt_text": "Playground with slides, bridges, and climbing structures at the Preston in McDonough, GA.",
        "public_id": "019d797b-30f2-7239-b189-7f8afd84bb66",
        "storage_key": "property/6767906449167339/019d797b-30f2-7239-b189-7f8afd84bb66.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides, bridges, and climbing structures perfect for children of all ages.",
      "link": "",
      "alt_text": "Playground with slides, bridges, and climbing structures at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f7eb865-9af3-4318-9427-8c496220ef65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-344b-774b-bf21-dc2cca8d366d.webp",
      "image_media": {
        "alt_text": "Apartment buildings with green lawns and trees under a blue sky at the Preston in McDonough, GA.",
        "public_id": "019d797b-344b-774b-bf21-dc2cca8d366d",
        "storage_key": "property/6767906449167339/019d797b-344b-774b-bf21-dc2cca8d366d.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Beautiful apartment buildings surrounded by lush green lawns and mature trees, offering a serene living environment.",
      "link": "",
      "alt_text": "Apartment buildings with green lawns and trees under a blue sky at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8536267-5a38-46df-9b16-b5aa87a2d69b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-306f-7776-bc19-00f3f04e459f.webp",
      "image_media": {
        "alt_text": "A large, sparkling blue swimming pool with a hot tub and lounge chairs at the Preston in McDonough, GA.",
        "public_id": "019d797b-306f-7776-bc19-00f3f04e459f",
        "storage_key": "property/6767906449167339/019d797b-306f-7776-bc19-00f3f04e459f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool and rejuvenating hot tub, surrounded by lush landscaping and comfortable seating.",
      "link": "",
      "alt_text": "A large, sparkling blue swimming pool with a hot tub and lounge chairs at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f1323fa-bb9f-4cce-8b5e-a390df5193f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-459c-75be-b7c3-7d2658c7580b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana on a sunny dayat the Preston in McDonough, GA.",
        "public_id": "019d797b-459c-75be-b7c3-7d2658c7580b",
        "storage_key": "property/6767906449167339/019d797b-459c-75be-b7c3-7d2658c7580b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a shaded cabana perfect for relaxing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana on a sunny dayat the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9087fe08-b3bb-4e83-840f-acea58ad99d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-2fbc-76cd-b5cd-c6bebd6b057e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a cabana at the Preston in McDonough, GA.",
        "public_id": "019d797b-2fbc-76cd-b5cd-c6bebd6b057e",
        "storage_key": "property/6767906449167339/019d797b-2fbc-76cd-b5cd-c6bebd6b057e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a cabana at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b28eabe2-54d1-4ac8-9627-6cc5630983b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-3201-76bd-85b8-5c705d943560.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of garages at an apartment complex at the Preston in McDonough, GA.",
        "public_id": "019d797b-3201-76bd-85b8-5c705d943560",
        "storage_key": "property/6767906449167339/019d797b-3201-76bd-85b8-5c705d943560.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure your vehicle in one of our spacious garages, available for rent at this apartment community.",
      "link": "",
      "alt_text": "Exterior view of a row of garages at an apartment complex at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fe0976f-bc79-4ed6-80f4-24e068e9d285",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-2fba-7659-8443-3530d2cafb24.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot in the foreground at the Preston in McDonough, GA.",
        "public_id": "019d797b-2fba-7659-8443-3530d2cafb24",
        "storage_key": "property/6767906449167339/019d797b-2fba-7659-8443-3530d2cafb24.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "The exterior of the apartment complex is shown, featuring multiple buildings with balconies and a parking lot with several cars.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a parking lot in the foreground at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f396ac2-5fd4-4e3a-8ff3-60652dcec6d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-2fa1-777d-be81-9ea24d83b07f.webp",
      "image_media": {
        "alt_text": "Outdoor grill and seating area next to swimming pool at the Preston in McDonough, GA.",
        "public_id": "019d797b-2fa1-777d-be81-9ea24d83b07f",
        "storage_key": "property/6767906449167339/019d797b-2fa1-777d-be81-9ea24d83b07f.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's built-in grill and comfortable seating, steps away from the refreshing swimming pool.",
      "link": "",
      "alt_text": "Outdoor grill and seating area next to swimming pool at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1c904c4-04ff-443d-a61d-af1fba337bc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797b-1a7f-74b8-8b35-b9837d32aba2.webp",
      "image_media": {
        "alt_text": "Building exterior with signage indicating future neighbor parking at the Preston in McDonough, GA.",
        "public_id": "019d797b-1a7f-74b8-8b35-b9837d32aba2",
        "storage_key": "property/6767906449167339/019d797b-1a7f-74b8-8b35-b9837d32aba2.webp",
        "width": 2369,
        "height": 1435
      },
      "title": "Community",
      "description": "Welcome to our community! This image showcases the welcoming exterior of our property, with clear signage for future neighbor parking. Enjoy the beautiful landscaping and inviting atmosphere.",
      "link": "",
      "alt_text": "Building exterior with signage indicating future neighbor parking at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b4a20275-dfa0-4bf7-97c5-2f77d44754df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-cf95-739d-bef1-7a54c5ac8bff.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered pavilion at the Preston in McDonough, GA.",
        "public_id": "019d797a-cf95-739d-bef1-7a54c5ac8bff",
        "storage_key": "property/6767906449167339/019d797a-cf95-739d-bef1-7a54c5ac8bff.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with ample lounge seating and a shaded pavilion for ultimate comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered pavilion at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3cdcca2d-5820-4836-9adf-30c1394bc2e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-cf57-7478-9f3e-fbb07bc9762d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
        "public_id": "019d797a-cf57-7478-9f3e-fbb07bc9762d",
        "storage_key": "property/6767906449167339/019d797a-cf57-7478-9f3e-fbb07bc9762d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Showcasing the exterior appeal of the apartment buildings, featuring individual balconies and beautifully landscaped grounds for a welcoming community feel.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1bb106d8-a7ae-4871-b714-5975a322ce32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-cd53-749c-9065-64aa0f02f3f3.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and surrounding landscaping at the Preston in McDonough, GA.",
        "public_id": "019d797a-cd53-749c-9065-64aa0f02f3f3",
        "storage_key": "property/6767906449167339/019d797a-cd53-749c-9065-64aa0f02f3f3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Beautiful apartment complex exterior featuring modern architecture, private balconies, and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and surrounding landscaping at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4b07b9b4-cc92-4dd0-adbf-902d6c801bd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-cddf-7626-871a-6ea51c16e80a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
        "public_id": "019d797a-cddf-7626-871a-6ea51c16e80a",
        "storage_key": "property/6767906449167339/019d797a-cddf-7626-871a-6ea51c16e80a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Showcases the exterior of the apartment buildings, featuring their architectural design, balconies, and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_085f86e1-f232-4de2-8e78-3755c3e4f7a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c7c3-749a-89dc-c53c27b3a883.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building entrance with a blue door and a white railing on a porch with autumn foliage in the background at the Preston in McDonough, GA.",
        "public_id": "019d797a-c7c3-749a-89dc-c53c27b3a883",
        "storage_key": "property/6767906449167339/019d797a-c7c3-749a-89dc-c53c27b3a883.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy your private porch entrance, perfect for relaxing and taking in the beautiful autumn scenery. This outdoor space offers a peaceful retreat.",
      "link": "",
      "alt_text": "Exterior view of an apartment building entrance with a blue door and a white railing on a porch with autumn foliage in the background at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6984164-88c7-4560-81f2-5c65a41475f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c490-776b-af90-405bedbefb20.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building entrance with a blue door and a window at the Preston in McDonough, GA.",
        "public_id": "019d797a-c490-776b-af90-405bedbefb20",
        "storage_key": "property/6767906449167339/019d797a-c490-776b-af90-405bedbefb20.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Community",
      "description": "This image shows the exterior of an apartment building, featuring a blue entrance door and a white-framed window. The building has beige siding and a wooden-planked overhang.",
      "link": "",
      "alt_text": "Exterior view of an apartment building entrance with a blue door and a window at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c7a66c8-6775-4ae5-b7e1-c73b7ac1f938",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-ca13-7268-8d1b-184c4d8e5b58.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees at the Preston in McDonough, GA.",
        "public_id": "019d797a-ca13-7268-8d1b-184c4d8e5b58",
        "storage_key": "property/6767906449167339/019d797a-ca13-7268-8d1b-184c4d8e5b58.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings showcasing their exterior architecture and surrounding green spaces. Ideal for a community overview.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and trees at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15213f11-f706-4a79-9478-d67b530690c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c490-776b-af90-4626bc1f2f97.webp",
      "image_media": {
        "alt_text": "Exterior patio with a blue door and a window leading to a dining room at the Preston in McDonough, GA.",
        "public_id": "019d797a-c490-776b-af90-4626bc1f2f97",
        "storage_key": "property/6767906449167339/019d797a-c490-776b-af90-4626bc1f2f97.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy your private outdoor patio, perfect for relaxing or entertaining, with direct access to your apartment's interior dining area.",
      "link": "",
      "alt_text": "Exterior patio with a blue door and a window leading to a dining room at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80236db5-e4b8-4a3d-a9c5-0a2983fc03c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c2d7-764f-91a1-d3c9b2b1a843.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building entrance with a blue door and a porch railing, surrounded by autumn foliage at the Preston in McDonough, GA.",
        "public_id": "019d797a-c2d7-764f-91a1-d3c9b2b1a843",
        "storage_key": "property/6767906449167339/019d797a-c2d7-764f-91a1-d3c9b2b1a843.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Community",
      "description": "Enjoy the beautiful autumn scenery from the comfort of your private porch. This exterior view showcases the welcoming entrance to your apartment home.",
      "link": "",
      "alt_text": "Exterior view of an apartment building entrance with a blue door and a porch railing, surrounded by autumn foliage at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93ccf5bb-433b-4264-aaa9-80def1f17a99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c2a8-70be-b408-d9f5116f3af9.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk and chair, walk-in closet entrance at the Preston in McDonough, GA.",
        "public_id": "019d797a-c2a8-70be-b408-d9f5116f3af9",
        "storage_key": "property/6767906449167339/019d797a-c2a8-70be-b408-d9f5116f3af9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a work-from-home setup with a desk and chair, and convenient access to a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a desk and chair, walk-in closet entrance at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94155b7c-f648-4ebe-842e-d43114ce4a4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c18c-7022-9d2d-21987480aa96.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, chair, and closet at the Preston in McDonough, GA.",
        "public_id": "019d797a-c18c-7022-9d2d-21987480aa96",
        "storage_key": "property/6767906449167339/019d797a-c18c-7022-9d2d-21987480aa96.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Comfortable bedroom with a queen-sized bed, plush armchair, and a spacious walk-in closet. Perfect for relaxation and storage.",
      "link": "",
      "alt_text": "Bedroom with a bed, chair, and closet at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7146f85-55e6-43c8-a126-d82410ca0e02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-c34e-765f-841f-6a5d2f77a79f.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, queen-size bed, and two windows at the Preston in McDonough, GA.",
        "public_id": "019d797a-c34e-765f-841f-6a5d2f77a79f",
        "storage_key": "property/6767906449167339/019d797a-c34e-765f-841f-6a5d2f77a79f.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Comfortable and inviting bedroom featuring a plush queen-size bed, modern ceiling fan, and abundant natural light from two large windows.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, queen-size bed, and two windows at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21ce6044-7a7c-41a8-b7a0-9508001c9e5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-bf1f-72df-8b01-f1873b3cd3e7.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, vanity, and shower with a light green curtain at the Preston in McDonough, GA.",
        "public_id": "019d797a-bf1f-72df-8b01-f1873b3cd3e7",
        "storage_key": "property/6767906449167339/019d797a-bf1f-72df-8b01-f1873b3cd3e7.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A clean and bright bathroom featuring a white vanity with a modern sink, a toilet, and a shower with a light green curtain. Includes ample storage space.",
      "link": "",
      "alt_text": "Bathroom with a toilet, vanity, and shower with a light green curtain at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de6717d5-2f17-4501-a00e-901ec8989b05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-be3e-7269-9a61-cdb04dcd4ea0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower with curtain at the Preston in McDonough, GA.",
        "public_id": "019d797a-be3e-7269-9a61-cdb04dcd4ea0",
        "storage_key": "property/6767906449167339/019d797a-be3e-7269-9a61-cdb04dcd4ea0.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a white vanity with marble countertop, toilet, and a shower/tub combo with a light blue curtain. Wood-look flooring adds warmth.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower with curtain at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9fbb8626-c811-4032-9b15-3f18aa09c83d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-bb68-7308-9929-a9a5148f5f64.webp",
      "image_media": {
        "alt_text": "Laundry room with two white washing machines and shelves at the Preston in McDonough, GA.",
        "public_id": "019d797a-bb68-7308-9929-a9a5148f5f64",
        "storage_key": "property/6767906449167339/019d797a-bb68-7308-9929-a9a5148f5f64.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities with washer, dryer, and ample storage shelving.",
      "link": "",
      "alt_text": "Laundry room with two white washing machines and shelves at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ac70284-430f-4909-bf53-0c91a7214969",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b639-748c-afb4-9ddf8673f297.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink at the Preston in McDonough, GA.",
        "public_id": "019d797a-b639-748c-afb4-9ddf8673f297",
        "storage_key": "property/6767906449167339/019d797a-b639-748c-afb4-9ddf8673f297.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this beautifully appointed kitchen, featuring ample cabinet space, sleek countertops, and modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e128200c-47a2-471c-954a-66185b6cb4dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b759-76f0-8934-bed664cd0c67.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room with shelves at the Preston in McDonough, GA.",
        "public_id": "019d797a-b759-76f0-8934-bed664cd0c67",
        "storage_key": "property/6767906449167339/019d797a-b759-76f0-8934-bed664cd0c67.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, with extra shelving for storage.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry room with shelves at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0ca08a0-6bd7-41fd-81b0-03a29a4d2e7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b4a6-761c-a9d8-f6399378fb44.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at the Preston in McDonough, GA.",
        "public_id": "019d797a-b4a6-761c-a9d8-f6399378fb44",
        "storage_key": "property/6767906449167339/019d797a-b4a6-761c-a9d8-f6399378fb44.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Discover this modern kitchen featuring sleek stainless steel appliances, ample white cabinetry, and elegant countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3165e95-8afd-43a2-97db-b0bf094a10af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b5dc-756d-bc8d-dac50294ddb1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white countertops at the Preston in McDonough, GA.",
        "public_id": "019d797a-b5dc-756d-bc8d-dac50294ddb1",
        "storage_key": "property/6767906449167339/019d797a-b5dc-756d-bc8d-dac50294ddb1.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant white countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white countertops at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdca9f81-a929-42c4-823d-48dcff4abc75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b342-744d-bcfc-1e6ccbdfc320.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink at the Preston in McDonough, GA.",
        "public_id": "019d797a-b342-744d-bcfc-1e6ccbdfc320",
        "storage_key": "property/6767906449167339/019d797a-b342-744d-bcfc-1e6ccbdfc320.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen featuring ample cabinet space, a deep sink, and modern appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0fa0716-6a1f-4203-9f43-3737866ef548",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b253-70a7-8a0e-df48da3f3ccb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, and stainless steel appliances at the Preston in McDonough, GA.",
        "public_id": "019d797a-b253-70a7-8a0e-df48da3f3ccb",
        "storage_key": "property/6767906449167339/019d797a-b253-70a7-8a0e-df48da3f3ccb.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Discover the sophisticated design of our kitchens, featuring sleek quartz countertops, ample white cabinetry, and modern stainless steel appliances for a seamless cooking experience.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, quartz countertops, and stainless steel appliances at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1eccd9a7-a173-4c43-9983-40d07f4fe333",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b0bd-7005-875d-21df23993164.webp",
      "image_media": {
        "alt_text": "Dining room with round wooden table, black chairs, and abstract art at the Preston in McDonough, GA.",
        "public_id": "019d797a-b0bd-7005-875d-21df23993164",
        "storage_key": "property/6767906449167339/019d797a-b0bd-7005-875d-21df23993164.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this stylish dining room, complete with a charming round table and seating for four. Perfect for intimate dinners or entertaining guests.",
      "link": "",
      "alt_text": "Dining room with round wooden table, black chairs, and abstract art at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_966bcea6-0c60-418b-adde-564f74fc9a8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b1dc-714b-8b04-c25621a4959d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops at the Preston in McDonough, GA.",
        "public_id": "019d797a-b1dc-714b-8b04-c25621a4959d",
        "storage_key": "property/6767906449167339/019d797a-b1dc-714b-8b04-c25621a4959d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Discover this beautiful kitchen, featuring stainless steel appliances, ample cabinet storage, and sleek quartz countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b684d900-3aec-433c-92cd-1b3971ff8646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b11a-722a-aeec-095fd1b7dc44.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and light wood flooring at the Preston in McDonough, GA.",
        "public_id": "019d797a-b11a-722a-aeec-095fd1b7dc44",
        "storage_key": "property/6767906449167339/019d797a-b11a-722a-aeec-095fd1b7dc44.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "This apartment kitchen features sleek stainless steel appliances, including a refrigerator, microwave, and oven. White cabinetry and light wood floors create a bright and airy feel.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and light wood flooring at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d8b3557-0a2c-419f-9646-d9106a646879",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-b007-732e-a044-9b2569e841ab.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, two yellow chairs, a coffee table, and a ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797a-b007-732e-a044-9b2569e841ab",
        "storage_key": "property/6767906449167339/019d797a-b007-732e-a044-9b2569e841ab.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Cozy and stylish living room featuring a modern blue sofa, two accent chairs, a round coffee table, and a ceiling fan, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a blue sofa, two yellow chairs, a coffee table, and a ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5aa01b6c-4a24-42f0-a106-5f47030fff0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a32e-719b-ace0-c1e3450aaf0a.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, nightstands, and a view into the bathroom at the Preston in McDonough, GA.",
        "public_id": "019d797a-a32e-719b-ace0-c1e3450aaf0a",
        "storage_key": "property/6767906449167339/019d797a-a32e-719b-ace0-c1e3450aaf0a.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed, modern nightstands, and a ceiling fan. Adjacent bathroom visible through doorway.",
      "link": "",
      "alt_text": "A bedroom with a bed, nightstands, and a view into the bathroom at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03996cd7-80cd-47b9-82a5-b8fee05f3530",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a5b8-7731-8123-ad3ce81836a0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and abstract art at the Preston in McDonough, GA.",
        "public_id": "019d797a-a5b8-7731-8123-ad3ce81836a0",
        "storage_key": "property/6767906449167339/019d797a-a5b8-7731-8123-ad3ce81836a0.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Experience comfort in our well-appointed bedrooms, featuring a plush queen-size bed, stylish nightstands, and tasteful decor. Perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and abstract art at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e7ac4f2-471e-46ce-bd7d-d14835394135",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a639-7085-82fc-130f26cac6c6.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with blue sofa, yellow chairs, coffee table, and kitchen island with bar stools at the Preston in McDonough, GA.",
        "public_id": "019d797a-a639-7085-82fc-130f26cac6c6",
        "storage_key": "property/6767906449167339/019d797a-a639-7085-82fc-130f26cac6c6.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with stainless steel appliances and a breakfast bar, flowing into a comfortable living room.",
      "link": "",
      "alt_text": "Living room and kitchen area with blue sofa, yellow chairs, coffee table, and kitchen island with bar stools at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba6b9016-fd5a-4e78-bcc1-4731fddf15b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a658-7067-9a0f-4876a13bb7f5.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table, four black chairs, and abstract art on the wall at the Preston in McDonough, GA.",
        "public_id": "019d797a-a658-7067-9a0f-4876a13bb7f5",
        "storage_key": "property/6767906449167339/019d797a-a658-7067-9a0f-4876a13bb7f5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy meals in your dining area, complete with a stylish round table, comfortable seating, and modern wall art.",
      "link": "",
      "alt_text": "Dining area with a round wooden table, four black chairs, and abstract art on the wall at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa1a64f2-08fc-42be-8de6-8afd630f371b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a56b-769f-974d-9861e6b2496c.webp",
      "image_media": {
        "alt_text": "Neutral-toned bathroom with a bathtub, shower curtain, and open shelving at the Preston in McDonough, GA.",
        "public_id": "019d797a-a56b-769f-974d-9861e6b2496c",
        "storage_key": "property/6767906449167339/019d797a-a56b-769f-974d-9861e6b2496c.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Step into a clean and functional bathroom featuring a bathtub with a stylish shower curtain and ample storage space with open shelving.",
      "link": "",
      "alt_text": "Neutral-toned bathroom with a bathtub, shower curtain, and open shelving at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ef3dd86-5ecf-4cf8-b200-eff36a21a391",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a384-70ca-8ad3-ac5926e700a9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and wood-look flooring at the Preston in McDonough, GA.",
        "public_id": "019d797a-a384-70ca-8ad3-ac5926e700a9",
        "storage_key": "property/6767906449167339/019d797a-a384-70ca-8ad3-ac5926e700a9.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Step into comfort with this modern apartment bathroom, featuring a spacious vanity, sleek fixtures, and elegant wood-look flooring for a touch of luxury.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and wood-look flooring at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f18451f-8a40-4076-a722-e5c9c2326edf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a1bc-73a3-9964-f248b52cfe6b.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstands, and doorway to bathroom at the Preston in McDonough, GA.",
        "public_id": "019d797a-a1bc-73a3-9964-f248b52cfe6b",
        "storage_key": "property/6767906449167339/019d797a-a1bc-73a3-9964-f248b52cfe6b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, modern nightstands, and a private entrance to the en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a bed, nightstands, and doorway to bathroom at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9e4f50a-80a9-4f6f-a7c3-3dce85c24174",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a5f5-727a-8b69-2733d2f0a379.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four, adjacent to a kitchen at the Preston in McDonough, GA.",
        "public_id": "019d797a-a5f5-727a-8b69-2733d2f0a379",
        "storage_key": "property/6767906449167339/019d797a-a5f5-727a-8b69-2733d2f0a379.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, perfectly situated next to a fully equipped kitchen. Ideal for entertaining or everyday dining.",
      "link": "",
      "alt_text": "Dining area with a round table set for four, adjacent to a kitchen at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ebe5d75-1164-4405-b0c1-b78d379fdc3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-a134-74ff-8beb-fc1d1e6da709.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan at the Preston in McDonough, GA.",
        "public_id": "019d797a-a134-74ff-8beb-fc1d1e6da709",
        "storage_key": "property/6767906449167339/019d797a-a134-74ff-8beb-fc1d1e6da709.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern nightstands, and a cooling ceiling fan. An ensuite bathroom is visible through the open doorway.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15461f07-cc9f-4061-9309-59281a84fcd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-95bd-75ba-b92a-68e8bbb84ee3.webp",
      "image_media": {
        "alt_text": "A modern conference room with a large table, chairs, and laptops, with lounge seating and artwork on the walls at the Preston in McDonough, GA.",
        "public_id": "019d797a-95bd-75ba-b92a-68e8bbb84ee3",
        "storage_key": "property/6767906449167339/019d797a-95bd-75ba-b92a-68e8bbb84ee3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Conduct business or host meetings in our well-appointed conference room, featuring comfortable seating and ample workspace for your productivity needs.",
      "link": "",
      "alt_text": "A modern conference room with a large table, chairs, and laptops, with lounge seating and artwork on the walls at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_998a01ed-e058-4e55-a6d4-3db629054e5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-9741-70d8-88a7-280adf6705bb.webp",
      "image_media": {
        "alt_text": "Brightly lit co-working space with a large conference table and chairs, lounge seating, and artwork at the Preston in McDonough, GA.",
        "public_id": "019d797a-9741-70d8-88a7-280adf6705bb",
        "storage_key": "property/6767906449167339/019d797a-9741-70d8-88a7-280adf6705bb.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Collaborate and connect in our stylish co-working space, designed for productivity and comfort.",
      "link": "",
      "alt_text": "Brightly lit co-working space with a large conference table and chairs, lounge seating, and artwork at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af0de621-2757-4d4d-9d3b-648e63c5caa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-95df-77f6-9a83-aeba8d17ed1c.webp",
      "image_media": {
        "alt_text": "Lobby of The Preston apartment complex with lounge seating, a coffee bar, and a large wood accent wall featuring the property's logo at the Preston in McDonough, GA.",
        "public_id": "019d797a-95df-77f6-9a83-aeba8d17ed1c",
        "storage_key": "property/6767906449167339/019d797a-95df-77f6-9a83-aeba8d17ed1c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to The Preston apartment community! Relax and socialize in our beautifully appointed lobby, featuring comfortable seating, a modern coffee bar, and elegant decor. Enjoy the spacious and inviting atmosphere.",
      "link": "",
      "alt_text": "Lobby of The Preston apartment complex with lounge seating, a coffee bar, and a large wood accent wall featuring the property's logo at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49fda75f-865a-4f66-8444-0b0208fb9f3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-96f3-7512-9b1d-95c82bd2f2cf.webp",
      "image_media": {
        "alt_text": "The Preston Iconic Living logo mounted on a wooden accent wall above a fireplace at the Preston in McDonough, GA.",
        "public_id": "019d797a-96f3-7512-9b1d-95c82bd2f2cf",
        "storage_key": "property/6767906449167339/019d797a-96f3-7512-9b1d-95c82bd2f2cf.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to The Preston Iconic Living community lounge, featuring a stylish fireplace, comfortable seating, and a large television.",
      "link": "",
      "alt_text": "The Preston Iconic Living logo mounted on a wooden accent wall above a fireplace at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d5735ea-c4c2-4347-95a9-391f5d63fb0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-95bc-743b-93ec-625069990d7f.webp",
      "image_media": {
        "alt_text": "The Preston Iconic Living community lounge area with seating and a fireplace at the Preston in McDonough, GA.",
        "public_id": "019d797a-95bc-743b-93ec-625069990d7f",
        "storage_key": "property/6767906449167339/019d797a-95bc-743b-93ec-625069990d7f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish community lounge at The Preston Iconic Living, featuring comfortable seating and a cozy fireplace.",
      "link": "",
      "alt_text": "The Preston Iconic Living community lounge area with seating and a fireplace at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fdf1c1f-4400-4abe-bffe-806c87b2cff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-95d4-761a-ba41-03d0a9798ad4.webp",
      "image_media": {
        "alt_text": "Community lounge area with a small table and chairs, large windows, and modern art at the Preston in McDonough, GA.",
        "public_id": "019d797a-95d4-761a-ba41-03d0a9798ad4",
        "storage_key": "property/6767906449167339/019d797a-95d4-761a-ba41-03d0a9798ad4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring comfortable seating, ample natural light, and stylish decor.",
      "link": "",
      "alt_text": "Community lounge area with a small table and chairs, large windows, and modern art at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4969ded5-0bcb-4a5a-ba25-3fbc0c405c7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-9555-76f9-8d4f-a9e5f03fee68.webp",
      "image_media": {
        "alt_text": "Spacious and bright community room with wood floors, modern furniture, and artwork at the Preston in McDonough, GA.",
        "public_id": "019d797a-9555-76f9-8d4f-a9e5f03fee68",
        "storage_key": "property/6767906449167339/019d797a-9555-76f9-8d4f-a9e5f03fee68.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy the ample space and modern design of our community room, perfect for gatherings and events.",
      "link": "",
      "alt_text": "Spacious and bright community room with wood floors, modern furniture, and artwork at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b51929c3-5018-46cf-a1a1-edbad60c1e5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-9583-77ea-a273-34896722a834.webp",
      "image_media": {
        "alt_text": "Modern lobby with plush seating and a Preston name sign at the Preston in McDonough, GA.",
        "public_id": "019d797a-9583-77ea-a273-34896722a834",
        "storage_key": "property/6767906449167339/019d797a-9583-77ea-a273-34896722a834.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and the Preston name prominently displayed.",
      "link": "",
      "alt_text": "Modern lobby with plush seating and a Preston name sign at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe91547e-3d50-40bb-aa3c-95bde4d166cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-95c7-7713-973e-b1aeed848e0c.webp",
      "image_media": {
        "alt_text": "Community lounge area with coffee bar and seating at the Preston in McDonough, GA.",
        "public_id": "019d797a-95c7-7713-973e-b1aeed848e0c",
        "storage_key": "property/6767906449167339/019d797a-95c7-7713-973e-b1aeed848e0c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy our modern lounge area, complete with a coffee bar and comfortable seating, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Community lounge area with coffee bar and seating at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8576a42-5ea3-4a4f-a3b4-96846a4e6737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797a-96a6-7699-bcbe-a3f0b31db9b6.webp",
      "image_media": {
        "alt_text": "Reception area with two desks, comfortable seating, and modern art at the Preston in McDonough, GA.",
        "public_id": "019d797a-96a6-7699-bcbe-a3f0b31db9b6",
        "storage_key": "property/6767906449167339/019d797a-96a6-7699-bcbe-a3f0b31db9b6.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to our leasing office, featuring a bright and airy reception area with comfortable seating and modern decor.",
      "link": "",
      "alt_text": "Reception area with two desks, comfortable seating, and modern art at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_535d1fab-ba80-4f64-a1b3-8be841a7ae8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex exterior, showcasing well-kept grounds and architectural details of the buildings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns at the Preston in McDonough, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6024253-79e9-4c0e-ba15-ae5a7476b348",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019f5d0e-bc4d-71b7-883f-bd2a93b01e34.webp",
      "image_media": {
        "alt_text": "People socializing in the community lounge area with a bar and seating.",
        "public_id": "019f5d0e-bc4d-71b7-883f-bd2a93b01e34",
        "storage_key": "property/6767906449167339/019f5d0e-bc4d-71b7-883f-bd2a93b01e34.webp",
        "width": 1476,
        "height": 1066
      },
      "title": "Community",
      "description": "Relax and connect with neighbors in our stylish community lounge, featuring comfortable seating, a modern bar, and a cozy fireplace area.",
      "link": "",
      "alt_text": "People socializing in the community lounge area with a bar and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de8f3566-a852-4c1f-8915-501a96ec3b57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019f5d0e-8508-74e7-9452-921160c8bcb4.webp",
      "image_media": {
        "alt_text": "People enjoying a large outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f5d0e-8508-74e7-9452-921160c8bcb4",
        "storage_key": "property/6767906449167339/019f5d0e-8508-74e7-9452-921160c8bcb4.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable lounge chairs and lush landscaping. Perfect for soaking up the sun or taking a refreshing dip.",
      "link": "",
      "alt_text": "People enjoying a large outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fb1a73d8-d389-4673-9642-4c055f224bf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1842 Jonesboro Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and Texas toast. They also highlight the quick and friendly service, and the fresh, hot food.\n\nOther reviews mention the chicken can be inconsistently seasoned.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-4e2b-7438-9b85-01d7b7472a26.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Raising Cane's restaurant with outdoor seating and a bright blue sky.",
        "public_id": "019d797d-4e2b-7438-9b85-01d7b7472a26",
        "storage_key": "property/6767906449167339/019d797d-4e2b-7438-9b85-01d7b7472a26.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ga/mcdonough/1842-jonesboro-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=16649033082573803649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "33.4648647",
      "poi_longitude": "-84.21533749999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-257-9391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d5505-4e35-719e-a8f2-b82f58111e8a",
        "storage_key": "property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-aLFgBZ9IgRgdCJ1GA_Dec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b19e9235-107a-4a4a-8431-be362785a2e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Dave & Buster's McDonough",
      "poi_type": "Restaurants",
      "poi_address": "239 Hwy 81, McDonough, GA 30253, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Diners say this restaurant serves up delicious salmon, burgers, and $5 drinks. They also highlight the family-friendly atmosphere with engaging games, making it a great spot for a fun outing.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-615b-722d-a67d-1811d5a48602.webp",
      "poi_featured_image_media": {
        "alt_text": "People cheering while watching football on multiple screens in a bar.",
        "public_id": "019d797d-615b-722d-a67d-1811d5a48602",
        "storage_key": "property/6767906449167339/019d797d-615b-722d-a67d-1811d5a48602.webp",
        "width": 3072,
        "height": 2074
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/mcdonough",
      "poi_directions_map_url": "https://maps.google.com/?cid=16015857843777103712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dave--busters-mcdonough",
      "poi_latitude": "33.4269126",
      "poi_longitude": "-84.1893753",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-282-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d5505-4e35-719e-a8f2-b82f58111e8a",
        "storage_key": "property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJay1e4VxZ9IgRYOd8b9rBQ94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_33ea62e1-30b2-4094-86d6-dd915943b64e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "101 S Point Blvd, McDonough, GA 30253, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves juicy and tender salmon, and delicious rolls with cinnamon butter. They also highlight the attentive staff, quick service, and fun, energetic atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5501-c526-7559-a9ca-f7722d7c39d7.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Texas Roadhouse restaurant at dusk.",
        "public_id": "019d5501-c526-7559-a9ca-f7722d7c39d7",
        "storage_key": "property/6767906449167339/019d5501-c526-7559-a9ca-f7722d7c39d7.webp",
        "width": 3072,
        "height": 1611
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/mcdonough?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=17033097786939709743&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.4222884",
      "poi_longitude": "-84.1888792",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-759-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d5505-4e35-719e-a8f2-b82f58111e8a",
        "storage_key": "property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSEjd6VZ9IgRL5kIJzG4Yew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0e5c0529-cd3a-4b55-a4c6-b6c1b17bea23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1755 Jonesboro Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food options, including steak, fried chicken, and a salad bar. They also highlight the attentive and friendly service, and the clean atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-4bef-741b-abb6-91d72e288c7d.webp",
      "poi_featured_image_media": {
        "alt_text": "Golden Corral restaurant entrance at dusk with illuminated signage and people walking.",
        "public_id": "019d797d-4bef-741b-abb6-91d72e288c7d",
        "storage_key": "property/6767906449167339/019d797d-4bef-741b-abb6-91d72e288c7d.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2483/golden-corral-jonesboro-road?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2483",
      "poi_directions_map_url": "https://maps.google.com/?cid=8818397248457950592&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "33.4625592",
      "poi_longitude": "-84.212929",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-432-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d5505-4e35-719e-a8f2-b82f58111e8a",
        "storage_key": "property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzxsmI8dZ9IgRgEWeWpM9YXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_8e59cf00-efcd-48d6-9dbf-3f20dd7e6516",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "90 Hwy 81, McDonough, GA 30253, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, fries, and frozen custard. They highlight the fresh, quality ingredients and the generous portions. They also like the clean facilities and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-560a-7376-bb5b-bb814d391ff7.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Culver's restaurant.",
        "public_id": "019d797d-560a-7376-bb5b-bb814d391ff7",
        "storage_key": "property/6767906449167339/019d797d-560a-7376-bb5b-bb814d391ff7.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.culvers.com/restaurants/mcdonough-ga-hwy-81/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=15836794613785772234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "33.4265569",
      "poi_longitude": "-84.1845992",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-782-3539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d5505-4e35-719e-a8f2-b82f58111e8a",
        "storage_key": "property/6767906449167339/019d5505-4e35-719e-a8f2-b82f58111e8a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWLxkFBa9IgRykCFV8uYx9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0f317aa7-9ef7-431a-8dc5-f174a672e570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1750 Jonesboro Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and supplies. They also highlight the helpful and knowledgeable staff, and the good prices.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5501-c789-704c-b33d-0e28c321f1f9.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior with a parking lot and cars.",
        "public_id": "019d5501-c789-704c-b33d-0e28c321f1f9",
        "storage_key": "property/6767906449167339/019d5501-c789-704c-b33d-0e28c321f1f9.webp",
        "width": 2714,
        "height": 2036
      },
      "poi_business_url": "https://www.homedepot.com/l/Mcdonough/GA/Mcdonough/30253/157?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9949153100382437372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.4655874",
      "poi_longitude": "-84.2128055",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-432-5827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e40-740d-b665-806e563b7818.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiley face",
        "public_id": "019d5505-4e40-740d-b665-806e563b7818",
        "storage_key": "property/6767906449167339/019d5505-4e40-740d-b665-806e563b7818.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU94mo8ZZ9IgR_H9FLAh-Eoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_5017532a-884b-4702-ad63-69ac870727f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 GA-155 N, McDonough, GA 30252, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers a wide selection of products and great prices. They also highlight the clean and well-stocked store, and the friendly and helpful staff.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5501-c3d7-702b-a63e-22f619bb685d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Kroger grocery store and pharmacy with blue sky.",
        "public_id": "019d5501-c3d7-702b-a63e-22f619bb685d",
        "storage_key": "property/6767906449167339/019d5501-c3d7-702b-a63e-22f619bb685d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/mcdonough/union-grove-marketplace/011/00633?cid=loc_01100633_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=114050314405788589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "33.5045735",
      "poi_longitude": "-84.1394507",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-379-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e98-7559-a3c2-94cc7b5b4b6f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d5505-4e98-7559-a3c2-94cc7b5b4b6f",
        "storage_key": "property/6767906449167339/019d5505-4e98-7559-a3c2-94cc7b5b4b6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzgUuyxX9IgRrbutHCgwlQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a6f422c9-3401-4cd3-9278-7278e20858bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1040 Chen Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, organic produce, including fruits, vegetables, and sprouts, as well as specialty brands and cooked meals. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-59ec-75ec-a647-d05d1346353b.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior storefront of Sprouts Farmers Market with \"Organic\" and \"Wellness\" signs.",
        "public_id": "019d797d-59ec-75ec-a647-d05d1346353b",
        "storage_key": "property/6767906449167339/019d797d-59ec-75ec-a647-d05d1346353b.webp",
        "width": 2111,
        "height": 1191
      },
      "poi_business_url": "https://www.sprouts.com/store/ga/stockbridge/jodeco-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5880203341126879679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "33.480132",
      "poi_longitude": "-84.223027",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-470-0983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e98-7559-a3c2-94cc7b5b4b6f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d5505-4e98-7559-a3c2-94cc7b5b4b6f",
        "storage_key": "property/6767906449167339/019d5505-4e98-7559-a3c2-94cc7b5b4b6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhT75j1xZ9IgRv8nuusitmlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5d9972c1-0d3e-4d85-880c-c9b5268f75c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Publix Super Market at Paradise Pointe at Lake Dow",
      "poi_type": "Shopping & Retail",
      "poi_address": "920 Hwy 81, McDonough, GA 30252, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, quality meats, and household essentials, as well as a deli and bakery known for their freshness and efficiency. They highlight the clean and organized store, and the friendly, helpful, and attentive staff. They also like the convenient self-checkout and the availability of BOGO sales.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-4d5a-728c-b914-135b7e704632.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix Food & Pharmacy logo at night.",
        "public_id": "019d797d-4d5a-728c-b914-135b7e704632",
        "storage_key": "property/6767906449167339/019d797d-4d5a-728c-b914-135b7e704632.webp",
        "width": 1493,
        "height": 3072
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=816&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=5195478592191819664&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-paradise-pointe-at-lake-dow",
      "poi_latitude": "33.4370673",
      "poi_longitude": "-84.12135310000001",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-898-1213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e98-7559-a3c2-94cc7b5b4b6f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d5505-4e98-7559-a3c2-94cc7b5b4b6f",
        "storage_key": "property/6767906449167339/019d5505-4e98-7559-a3c2-94cc7b5b4b6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Rw08t5a9IgRkG-9tUAMGkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_54349c3d-ad86-4463-bd4b-9e518e663e63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 Jonesboro Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of products, including clothing, shoes, and household goods. They also highlight the affordable prices and the potential to find good deals.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-4cab-71fb-b0ef-02d9b5ddfbda.webp",
      "poi_featured_image_media": {
        "alt_text": "Ross Dress for Less store exterior.",
        "public_id": "019d797d-4cab-71fb-b0ef-02d9b5ddfbda",
        "storage_key": "property/6767906449167339/019d797d-4cab-71fb-b0ef-02d9b5ddfbda.webp",
        "width": 1841,
        "height": 1037
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14316218436443252129&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "33.4677435",
      "poi_longitude": "-84.2189049",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-432-7556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e40-740d-b665-806e563b7818.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiley face",
        "public_id": "019d5505-4e40-740d-b665-806e563b7818",
        "storage_key": "property/6767906449167339/019d5505-4e40-740d-b665-806e563b7818.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ56HNbMlZ9IgRoSUZP9FsrcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e5f201a1-6ac2-4f4d-bee1-3d145aa2263a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Southern Crescent Technical College - Henry County Center",
      "poi_type": "Education",
      "poi_address": "300 Lakemont Dr, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5501-eb15-700f-8f6d-34643098e7fe.webp",
      "poi_featured_image_media": {
        "alt_text": "Southern Crescent Technical College Henry County Center building exterior with monument sign.",
        "public_id": "019d5501-eb15-700f-8f6d-34643098e7fe",
        "storage_key": "property/6767906449167339/019d5501-eb15-700f-8f6d-34643098e7fe.webp",
        "width": 3072,
        "height": 2051
      },
      "poi_business_url": "http://www.sctech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2104823421855839159&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-crescent-technical-college---henry-county-center",
      "poi_latitude": "33.4468231",
      "poi_longitude": "-84.127201",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-914-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e59-71a9-9f58-b79904ea6e27.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d5505-4e59-71a9-9f58-b79904ea6e27",
        "storage_key": "property/6767906449167339/019d5505-4e59-71a9-9f58-b79904ea6e27.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ69qQx-ha9IgRt7OjFsDVNR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3c99169a-633e-4a71-b0ca-f68319e38c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "1970 Jonesboro Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities, including trampolines, zip lines, obstacle courses, and laser tag. They also highlight the friendly and attentive staff, and the clean and well-maintained facility.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-4c58-7634-94e2-3ece420063f4.webp",
      "poi_featured_image_media": {
        "alt_text": "Children celebrating a birthday party with cake and balloons.",
        "public_id": "019d797d-4c58-7634-94e2-3ece420063f4",
        "storage_key": "property/6767906449167339/019d797d-4c58-7634-94e2-3ece420063f4.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.urbanair.com/georgia-mcdonough/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11826025596989562843&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "33.4657623",
      "poi_longitude": "-84.2204167",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-552-1908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_hZMJ5Z9IgR2189nZ97HqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c612337d-8d3c-4142-b5ce-5d9551f8b924",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "165 Mill Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, slides, swings, and a basketball court. They also highlight the friendly and helpful staff, and the clean facility.\n\nOther reviews mention some attractions can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5501-f844-71f0-925b-f6eba6fbc2b3.webp",
      "poi_featured_image_media": {
        "alt_text": "Person jumping in the air wearing Sky Zone socks.",
        "public_id": "019d5501-f844-71f0-925b-f6eba6fbc2b3",
        "storage_key": "property/6767906449167339/019d5501-f844-71f0-925b-f6eba6fbc2b3.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.skyzone.com/mcdonough/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11749740995697797351&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "33.4584842",
      "poi_longitude": "-84.21004459999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-914-9444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfAFDr9Z9IgR52hpyy53D6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c0e22946-d0b4-4d7e-8793-0ec449080902",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Jason T. Harper Event Center",
      "poi_type": "Entertainment",
      "poi_address": "95 Lake Dow Rd, McDonough, GA 30252, USA",
      "poi_short_description": "Venue offering free admission for events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-721c-76cc-848f-20957aa3a3f5.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered outdoor sports court with bleacher seating.",
        "public_id": "019d797d-721c-76cc-848f-20957aa3a3f5",
        "storage_key": "property/6767906449167339/019d797d-721c-76cc-848f-20957aa3a3f5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16889241564645520127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jason-t-harper-event-center",
      "poi_latitude": "33.4408243",
      "poi_longitude": "-84.12324249999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-288-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9NjxN1a9IgR_3J1UrijYuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_036f7b72-71a7-48d4-b798-bd766f7f79eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Bulldog Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Henry County, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-68b6-72e9-aec7-80c8c03a1241.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a football stadium with track and field.",
        "public_id": "019d797d-68b6-72e9-aec7-80c8c03a1241",
        "storage_key": "property/6767906449167339/019d797d-68b6-72e9-aec7-80c8c03a1241.webp",
        "width": 1464,
        "height": 827
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7165870118906393272&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bulldog-stadium",
      "poi_latitude": "33.4706713",
      "poi_longitude": "-84.2500695",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-b5da-7292-ad3c-1a58d9f85173.webp",
      "poi_map_icon_media": {
        "alt_text": "Two figures sitting at a table icon",
        "public_id": "019d797d-b5da-7292-ad3c-1a58d9f85173",
        "storage_key": "property/6767906449167339/019d797d-b5da-7292-ad3c-1a58d9f85173.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmZxq12ZZ9IgRuHIAIOhIcmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_17017d93-eb9e-45f8-a04d-ed25cf138f16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Image Doctor's Camera Museum",
      "poi_type": "Entertainment",
      "poi_address": "369 Macon St, McDonough, GA 30253, USA",
      "poi_short_description": "Place showcasing antique cameras, offering photography classes and restorative photo touching.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-7608-7052-9a6b-abf3942122e2.webp",
      "poi_featured_image_media": {
        "alt_text": "Vintage Zeiss Ikon camera",
        "public_id": "019d797d-7608-7052-9a6b-abf3942122e2",
        "storage_key": "property/6767906449167339/019d797d-7608-7052-9a6b-abf3942122e2.webp",
        "width": 3024,
        "height": 1702
      },
      "poi_business_url": "http://www.camera-museum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14474557076001960961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "image-doctors-camera-museum",
      "poi_latitude": "33.4372664",
      "poi_longitude": "-84.1466221",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-892-0042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e50-7428-8384-1864bcc2e7c2.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a building with the letter M inside",
        "public_id": "019d5505-4e50-7428-8384-1864bcc2e7c2",
        "storage_key": "property/6767906449167339/019d5505-4e50-7428-8384-1864bcc2e7c2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE5Btylla9IgRAbQ2nPj038g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d3fbb8bf-20a4-4524-b5d0-4dc7dfd6d07b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Fitness 2020 - McDonough",
      "poi_type": "Health and Wellness",
      "poi_address": "1090 Regency Plaza Blvd #100, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide range of equipment, including free weights, resistance machines, and cardio equipment, as well as a pool and indoor track. They also highlight the clean and well-maintained facility, and the friendly and helpful staff.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-698f-7029-8e73-54be04fbfab6.webp",
      "poi_featured_image_media": {
        "alt_text": "Fitness 2020 gym exterior entrance with sign.",
        "public_id": "019d797d-698f-7029-8e73-54be04fbfab6",
        "storage_key": "property/6767906449167339/019d797d-698f-7029-8e73-54be04fbfab6.webp",
        "width": 514,
        "height": 421
      },
      "poi_business_url": "https://fitness2020.com/locations/mcdonough-home-page/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1272772841125403431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-2020---mcdonough",
      "poi_latitude": "33.431137",
      "poi_longitude": "-84.1740501",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-957-0804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Zic581b9IgRJ1sL0yfMqRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_82cd612c-21f3-468e-b86d-d5ab3687ef76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "252 Jonesboro Rd, McDonough, GA 30253, USA",
      "poi_short_description": "Chains like this one for workouts and massage chairs plus tanning beds.",
      "poi_long_description": "People say this gym offers a good selection of equipment and is always clean. They also highlight the friendly and helpful staff, and the positive atmosphere.\n\nOther reviews mention the crowd meter can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5501-fe93-75bd-aa2d-137593e998ef.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out on various weight machines in a brightly lit gym with purple and yellow equipment.",
        "public_id": "019d5501-fe93-75bd-aa2d-137593e998ef",
        "storage_key": "property/6767906449167339/019d5501-fe93-75bd-aa2d-137593e998ef.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/mcdonough-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484842399763479173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.4553798",
      "poi_longitude": "-84.16690249999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-898-6222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97oHRs5b9IgRhTpXqUs4mxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_964cb5d7-134f-4cd9-ac82-bc7caba944a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "95 Foster Dr, McDonough, GA 30253, USA",
      "poi_short_description": "Chain fitness center offering pools, a basketball court, and cardio and weight equipment, plus group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-0ef0-732e-a85c-2507563d36d1.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a modern gym with turf area, weight machines, and cardio equipment.",
        "public_id": "019d5502-0ef0-732e-a85c-2507563d36d1",
        "storage_key": "property/6767906449167339/019d5502-0ef0-732e-a85c-2507563d36d1.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=429&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17606984918636676947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.463867",
      "poi_longitude": "-84.20838189999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-228-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6z5l8FZ9IgRU8f_aH-TWPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4cd0999b-b8a3-4694-970c-01f8f427b90a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Fitness 2020 - Eagles Landing",
      "poi_type": "Health and Wellness",
      "poi_address": "200-200 Business Center Dr, Stockbridge, GA 30281, USA",
      "poi_short_description": "Modern gym featuring classes, free weights, exercise machines and a sauna.",
      "poi_long_description": "People say this gym offers a variety of equipment and has 24/7 access. They also highlight the friendly and professional staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-7662-71aa-9a95-ba8baf84b4ca.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious gym with cardio and weight machines",
        "public_id": "019d797d-7662-71aa-9a95-ba8baf84b4ca",
        "storage_key": "property/6767906449167339/019d797d-7662-71aa-9a95-ba8baf84b4ca.webp",
        "width": 816,
        "height": 460
      },
      "poi_business_url": "https://fitness2020.com/locations/eagles-landing-home-page/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15919879138821848092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-2020---eagles-landing",
      "poi_latitude": "33.5185974",
      "poi_longitude": "-84.20734159999999",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-565-8682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8I7JnRX9IgRHLygyLrF7tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f0ac44b7-43a6-451a-9215-3f6186833b4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1663 GA-20, McDonough, GA 30253, USA",
      "poi_short_description": "Chain gym offering full-body group classes that combine cardio and strength training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-2463-70f2-8841-d816516cb99b.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out on treadmills and rowing machines at an Orangetheory Fitness gym.",
        "public_id": "019d5502-2463-70f2-8841-d816516cb99b",
        "storage_key": "property/6767906449167339/019d5502-2463-70f2-8841-d816516cb99b.webp",
        "width": 2048,
        "height": 1153
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/mcdonough-georgia-1149?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=533278816017083022&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.4187926",
      "poi_longitude": "-84.190299",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-505-7877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJweWThDJZ9IgRjmrw-kGWZgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d8622b9e-a301-4732-ba26-ca9c15fc2f13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "5TH NAIL LOUNGE MCDONOUGH",
      "poi_type": "Health and Wellness",
      "poi_address": "2190 GA-20, McDonough, GA 30253, USA",
      "poi_short_description": "Relaxed nail salon offering manicures and pedicures with massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-77e7-750e-98f9-dc4a8bb61ea8.webp",
      "poi_featured_image_media": {
        "alt_text": "Nail Lounge logo with address and phone number",
        "public_id": "019d797d-77e7-750e-98f9-dc4a8bb61ea8",
        "storage_key": "property/6767906449167339/019d797d-77e7-750e-98f9-dc4a8bb61ea8.webp",
        "width": 1326,
        "height": 745
      },
      "poi_business_url": "https://5thnailloungemcdonough.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9835319806844267327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "5th-nail-lounge-mcdonough",
      "poi_latitude": "33.41255659999999",
      "poi_longitude": "-84.20290840000001",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-272-7552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaKmXWlVWGsRP-tQK0ETfog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_441d6b3d-8525-4dae-881f-eaea842ad7b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Tips & Toes Nail Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "2144 GA-20, McDonough, GA 30253, USA",
      "poi_short_description": "Nail salon located in the Shops at Westridge offering a range of services in a clean space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-76bf-73bb-a14c-ff8f47f66e4a.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of a hand with dark purple almond-shaped nails, tattoos, and a ring.",
        "public_id": "019d797d-76bf-73bb-a14c-ff8f47f66e4a",
        "storage_key": "property/6767906449167339/019d797d-76bf-73bb-a14c-ff8f47f66e4a.webp",
        "width": 1440,
        "height": 1440
      },
      "poi_business_url": "https://arveduidir.top/tips-toes-nail-spa-o9ioehq.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1446263313741408420&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tips--toes-nail-spa",
      "poi_latitude": "33.4141617",
      "poi_longitude": "-84.2020641",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-914-3345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwz437EBZ9IgRpGg8O9IoEhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ca69c409-217b-448d-9bbe-9f99bb1fcf76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Fitness 1440 - McDonough",
      "poi_type": "Health and Wellness",
      "poi_address": "294 Racetrack Rd #106, McDonough, GA 30252, USA",
      "poi_short_description": "Locally owned and operated 24-hour gym offering interval and TRX training, plus equipment and classes.",
      "poi_long_description": "People say this gym offers a wide variety of up-to-date equipment and machines, as well as spacious showers. They highlight the clean and well-maintained facilities, and the convenient 24/7 access. They also like the friendly and helpful staff, and the welcoming and supportive atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-81b9-72de-90ec-d0264a5de8ab.webp",
      "poi_featured_image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and barbells.",
        "public_id": "019d797d-81b9-72de-90ec-d0264a5de8ab",
        "storage_key": "property/6767906449167339/019d797d-81b9-72de-90ec-d0264a5de8ab.webp",
        "width": 1600,
        "height": 900
      },
      "poi_business_url": "https://www.fitness1440.com/mcdonough/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12583858351921968335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-1440---mcdonough",
      "poi_latitude": "33.430321",
      "poi_longitude": "-84.13494399999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-462-4345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4jSq6Rb9IgRzzQkun_Yoq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_107a98c0-4315-434e-bc7c-b95b4c2caed8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Glamour Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "250 Jonesboro Rd suite 230, McDonough, GA 30253, USA",
      "poi_short_description": "Nail salon whose menu covers manicures, pedicures and eyelash extensions, among other services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-86c9-718f-af25-d4d13969ac74.webp",
      "poi_featured_image_media": {
        "alt_text": "Nail technician applying rhinestones to a client's fingernail.",
        "public_id": "019d797d-86c9-718f-af25-d4d13969ac74",
        "storage_key": "property/6767906449167339/019d797d-86c9-718f-af25-d4d13969ac74.webp",
        "width": 2080,
        "height": 2080
      },
      "poi_business_url": "https://glamournailbarmcdonough.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12560205993908669423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glamour-nail-bar",
      "poi_latitude": "33.4550801",
      "poi_longitude": "-84.1661424",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-272-8874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-UburISt0gUR74uo_M3QTq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_dd72121b-cbf1-4f7c-bac8-fdc2c9814a5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "2374 Jonesboro Rd, Hampton, GA 30228, USA",
      "poi_short_description": "Reformer-based studio teaching Pilates for all experience levels and fitness goals in various formats.",
      "poi_long_description": "People say this pilates studio offers challenging classes with a variety of moves that help strengthen the core and improve flexibility. They also highlight the friendly and welcoming atmosphere, with supportive and knowledgeable instructors who provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-874a-76da-931b-db28bcd559bb.webp",
      "poi_featured_image_media": {
        "alt_text": "Pilates studio with multiple reformers lined up and a scenic mountain mural.",
        "public_id": "019d797d-874a-76da-931b-db28bcd559bb",
        "storage_key": "property/6767906449167339/019d797d-874a-76da-931b-db28bcd559bb.webp",
        "width": 2458,
        "height": 3072
      },
      "poi_business_url": "http://clubpilates.com/mcdonoughwest/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4544151190617366852&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "33.4659057",
      "poi_longitude": "-84.2338565",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-769-5848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e59-71a9-9f58-b79904ea6e27.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d5505-4e59-71a9-9f58-b79904ea6e27",
        "storage_key": "property/6767906449167339/019d5505-4e59-71a9-9f58-b79904ea6e27.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT_DRsOFZ9IgRRKFqkm4RED8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_24536826-adba-420c-8b5e-b2fd87c0a86a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Piedmont Henry",
      "poi_type": "Health and Wellness",
      "poi_address": "1133 Eagles Landing Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-86d8-71f9-9538-88b3a3caa4bc.webp",
      "poi_featured_image_media": {
        "alt_text": "Piedmont South Entrance building exterior",
        "public_id": "019d797d-86d8-71f9-9538-88b3a3caa4bc",
        "storage_key": "property/6767906449167339/019d797d-86d8-71f9-9538-88b3a3caa4bc.webp",
        "width": 2120,
        "height": 1192
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-henry-hospital?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4NzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16988970070758721226&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-henry",
      "poi_latitude": "33.5111408",
      "poi_longitude": "-84.2271275",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-5287-704c-b496-9bd094cc1c51.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019d5505-5287-704c-b496-9bd094cc1c51",
        "storage_key": "property/6767906449167339/019d5505-5287-704c-b496-9bd094cc1c51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBduprw5X9IgRygZRl0TyxOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1ff79634-286a-4892-bae5-cbb68a56bf9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Resurgens Orthopaedics",
      "poi_type": "Health and Wellness",
      "poi_address": "156 Foster Dr Ste B, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-8d8a-76bc-a45c-4720356bc49a.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the building entrance with a modern canopy and landscaping.",
        "public_id": "019d797d-8d8a-76bc-a45c-4720356bc49a",
        "storage_key": "property/6767906449167339/019d797d-8d8a-76bc-a45c-4720356bc49a.webp",
        "width": 740,
        "height": 630
      },
      "poi_business_url": "https://www.resurgens.com/mcdonough?utm_medium=organic&utm_source=GMBLocation&utm_content=McDonough",
      "poi_directions_map_url": "https://maps.google.com/?cid=10150030365514381163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "resurgens-orthopaedics",
      "poi_latitude": "33.4636206",
      "poi_longitude": "-84.20520239999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-847-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-5287-704c-b496-9bd094cc1c51.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019d5505-5287-704c-b496-9bd094cc1c51",
        "storage_key": "property/6767906449167339/019d5505-5287-704c-b496-9bd094cc1c51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3catM1b9IgRa7fpG9cm3Iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_198a7151-255a-4918-97db-7ac41eae1248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Eagles Landing Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Eagles Landing Way, Stockbridge, GA 30281, USA",
      "poi_short_description": "Eatery featuring 27 holes of championship golf plus a clubhouse with pools, tennis courts, dining rooms and an event venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-8f10-72af-88ef-7577976c26f4.webp",
      "poi_featured_image_media": {
        "alt_text": "Golf course with a large clubhouse and manicured greens.",
        "public_id": "019d797d-8f10-72af-88ef-7577976c26f4",
        "storage_key": "property/6767906449167339/019d797d-8f10-72af-88ef-7577976c26f4.webp",
        "width": 728,
        "height": 410
      },
      "poi_business_url": "https://www.eagleslandingcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15731791346613371941&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eagles-landing-country-club",
      "poi_latitude": "33.5091873",
      "poi_longitude": "-84.21552659999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-389-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-b5da-7292-ad3c-1454a022b49c.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person playing soccer",
        "public_id": "019d797d-b5da-7292-ad3c-1454a022b49c",
        "storage_key": "property/6767906449167339/019d797d-b5da-7292-ad3c-1454a022b49c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwXfbBJX9IgRJUR0D-GMUto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_30f51dda-ef7d-4d51-bc77-81cd3709364d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "99 Lake Dow Rd, McDonough, GA 30252, USA",
      "poi_short_description": "Public park with a concert arena & a replica 1820s village, plus a military monument & museum.",
      "poi_long_description": "People say this park offers walking trails, a playground, and a military museum. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails. They also like the historical significance and the opportunity to meet veterans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-40f3-705b-9935-96dc2e0878f0.webp",
      "poi_featured_image_media": {
        "alt_text": "Red barn building with Welcome to Heritage Village and Veterans Museum signage.",
        "public_id": "019d5502-40f3-705b-9935-96dc2e0878f0",
        "storage_key": "property/6767906449167339/019d5502-40f3-705b-9935-96dc2e0878f0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://ga-henrycounty.civicplus.pro/309/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=17381433874986675248&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "33.4419479",
      "poi_longitude": "-84.120531",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-288-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d5505-527a-765e-992e-0cb438a6fc94",
        "storage_key": "property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62DWvN1a9IgRMKyFvQRCN_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_40a105b8-7efc-4b69-a231-21a75e54819e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "North Mt. Carmel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "307 N Mt Carmel Rd, Hampton, GA 30228, USA",
      "poi_short_description": "This 129-acre community area boasts a large playground, jogging track, dog park & 14 soccer fields.",
      "poi_long_description": "People say this park offers a variety of recreational activities, including basketball courts, a gaming room, a gym, and soccer fields. They highlight the park's spaciousness, the availability of shaded seating areas, and the well-maintained dog park. They also like the friendly atmosphere and the updated amenities in the recreational center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-946c-73ae-9abc-3e179800d273.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground area with slides, swings, and climbing structures.",
        "public_id": "019d797d-946c-73ae-9abc-3e179800d273",
        "storage_key": "property/6767906449167339/019d797d-946c-73ae-9abc-3e179800d273.webp",
        "width": 3072,
        "height": 1730
      },
      "poi_business_url": "https://www.henrycountyga.gov/412/Recreation-Centers?contentId=f992d78d-1c18-40eb-ba7a-9a615c3157f3",
      "poi_directions_map_url": "https://maps.google.com/?cid=4842713537147023290&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-mt-carmel-park",
      "poi_latitude": "33.4530566",
      "poi_longitude": "-84.2461995",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-288-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d5505-527a-765e-992e-0cb438a6fc94",
        "storage_key": "property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVqvn0NY9IgRuq-f4k3GNEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c6e08dc8-2e62-4103-b306-20e5d7474d34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Richard Craig Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "125 S Zack Hinton Blvd, McDonough, GA 30253, USA",
      "poi_short_description": "39+ acres of green space with tennis courts, a playground, a pavilion & lighted baseball diamonds.",
      "poi_long_description": "39+ acres of green space with tennis courts, a playground, a pavilion & lighted baseball diamonds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-4489-732d-b14a-eb326ce9074d.webp",
      "poi_featured_image_media": {
        "alt_text": "People playing flag football on a grassy field on a sunny day.",
        "public_id": "019d5502-4489-732d-b14a-eb326ce9074d",
        "storage_key": "property/6767906449167339/019d5502-4489-732d-b14a-eb326ce9074d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11212445176348605845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richard-craig-park",
      "poi_latitude": "33.4361254",
      "poi_longitude": "-84.143461",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-288-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d5505-527a-765e-992e-0cb438a6fc94",
        "storage_key": "property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAy9rmv5a9IgRlf3MV3ubmps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bf9370bc-c3c0-46a9-8949-df9a6123b61d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Avalon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1068 Industrial Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "Spacious area featuring a splash pad, 2 playgrounds, a walking trail, an amphitheater, and an athletic field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-572f-7297-91be-37c99a5baa57.webp",
      "poi_featured_image_media": {
        "alt_text": "Football field with goalposts and bleachers, parking lot in background.",
        "public_id": "019d5502-572f-7297-91be-37c99a5baa57",
        "storage_key": "property/6767906449167339/019d5502-572f-7297-91be-37c99a5baa57.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.myahockey.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7193327535153962946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "avalon-park",
      "poi_latitude": "33.4167976",
      "poi_longitude": "-84.18288419999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-508-1457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d5505-527a-765e-992e-0cb438a6fc94",
        "storage_key": "property/6767906449167339/019d5505-527a-765e-992e-0cb438a6fc94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUkOpGFZ9IgRwl_jBUjV02M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7672824b-de98-4a8f-adf5-effa385cea79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Mallards Landing Airport-GA04",
      "poi_type": "Transportation & Transit",
      "poi_address": "Locust Grove, GA 30248, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1060617039111056041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mallards-landing-airport-ga04",
      "poi_latitude": "33.3646741",
      "poi_longitude": "-84.16780969999999",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-374-9641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-535c-742a-9229-6d0e4ae78f9e.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d5505-535c-742a-9229-6d0e4ae78f9e",
        "storage_key": "property/6767906449167339/019d5505-535c-742a-9229-6d0e4ae78f9e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0p9XeBP9IgRqerw4pMRuA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9adfa764-a1c5-4ee7-938a-2148b072df03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "BLUE BUFFALO",
      "poi_type": "Major Employers & Offices",
      "poi_address": "159 Westridge Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-96ce-772a-a1ea-8748e8dbad4e.webp",
      "poi_featured_image_media": {
        "alt_text": "Industrial building with loading docks and semi-trucks parked in lot.",
        "public_id": "019d797d-96ce-772a-a1ea-8748e8dbad4e",
        "storage_key": "property/6767906449167339/019d797d-96ce-772a-a1ea-8748e8dbad4e.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021584336762764932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-buffalo",
      "poi_latitude": "33.4108368",
      "poi_longitude": "-84.19392069999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-913-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcqrRV5Z9IgRhP6UQHRkUm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a1f83196-c8f2-4555-b00a-14130fe54a03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Sangsin Technology America",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1559 GA-155 S, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-9684-765f-a88d-4e1a989d3808.webp",
      "poi_featured_image_media": {
        "alt_text": "Rows of vehicle axles in a warehouse.",
        "public_id": "019d797d-9684-765f-a88d-4e1a989d3808",
        "storage_key": "property/6767906449167339/019d797d-9684-765f-a88d-4e1a989d3808.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11240940108620831010&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sangsin-technology-america",
      "poi_latitude": "33.3964685",
      "poi_longitude": "-84.1728195",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-766-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3zwXuFb9IgRIhnJw3jX_5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_71376f72-5d2d-4893-a67a-deb5f618084e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "Department Of Child Support Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2030 Avalon Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d797d-9741-76e1-9fdf-8c03f62efab4.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Division of Child Support Services building at 46 Sloan St.",
        "public_id": "019d797d-9741-76e1-9fdf-8c03f62efab4",
        "storage_key": "property/6767906449167339/019d797d-9741-76e1-9fdf-8c03f62efab4.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://childsupport.georgia.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17311453769716085437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "department-of-child-support-services",
      "poi_latitude": "33.4151931",
      "poi_longitude": "-84.1712541",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 877-423-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-omKVha9IgRvTKGyXujPvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_98a829c1-45e5-47db-8a8b-8d97d406f97d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "McDonough City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "136 Keys Ferry St, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.mcdonoughga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2147082619113528233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcdonough-city-hall",
      "poi_latitude": "33.4472723",
      "poi_longitude": "-84.14260209999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-957-3915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e50-7428-8384-1cb3042db433.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon",
        "public_id": "019d5505-4e50-7428-8384-1cb3042db433",
        "storage_key": "property/6767906449167339/019d5505-4e50-7428-8384-1cb3042db433.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxXo6fda9IgRqVutL0T4yx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2affcbca-b051-41d8-9c5d-45be6d6e9c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "custom",
      "poi_name": "DHL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "340 Westridge Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dhl.com/us-en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5356200167644980698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dhl",
      "poi_latitude": "33.4042901",
      "poi_longitude": "-84.1929612",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-561-9026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d5505-4e5b-76aa-8a31-4d6eac4bfeec",
        "storage_key": "property/6767906449167339/019d5505-4e5b-76aa-8a31-4d6eac4bfeec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eU8mJFZ9IgR2uVdkqwLVUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e178284d8eb822c5dd6b7f5a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_571a1c9f8e049e1644b407ec",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_774ea5da93fdbc97016c57a2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9ac5a961f85c6c71cc50d298",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a84e0e7c35ea0a1cf32cdbd8",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_60558318e8904dc98840467f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_930dbd8b-df1b-4cc0-a5a3-40a966cf73aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5.0",
      "name": "Keyanna Henderson",
      "text": "I love my newly remodeled apartment! I want to thank Krystie so much! She was very helpful with my moving process. We had one conversation and I can honestly say she came through 1000%. She kept in contact with me throughout the entire process, and any questions i had, she answered them! I really appreciate Krystie she went above and beyond to help me and my kids and we’re forever grateful for her!",
      "date": "2025-11-25",
      "title": ""
    },
    {
      "id": "custom_6e3823d5-55c1-46cf-81cf-c4280993ab06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5.0",
      "name": "Dominique Hill-Grier",
      "text": "New style, new management, and a new attitude! I lived at the Preston for several years and had a not so great experience throughout my stay. I have worked with several managers for over a year trying to track down my security deposit refund. I finally came in last week and spoke with the new manager Darryl and he not only got it located and reissued but he asked if I’d be interested to see their new renovation type apartment. Mind you, at no point did I mention that I was looking. But customer service came so naturally to him that he wanted to show me anyway to get my opinion as previous long standing tenant. It’s beautiful and this new company is doing the work! As a person who works hospitality and have done so for many years, I will never forget how that young man made me feel in that interaction. I am not even sure that he’s aware that I did this review but you folks gotta know that you have a jewel in that young fellow. He’s a rising star",
      "date": "2025-09-23",
      "title": ""
    },
    {
      "id": "custom_c6c060ee-69da-4868-b8d0-7bee2c560cfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5",
      "name": "Kimenthia Watson",
      "text": "This is the very first community that I have experienced nothing but professionalism. Mekhi, Jen and Josh, Orlando and Mike are the perfect examples of how they care for all their tenants! The entire maintenance team is awesome as well! I feel very safe in this complex! I would recommend others to apply and become apart of this team! I’m not worried about anything happening to my family! I’m just going to give the entire team EXCELLENT for their professionalism!! Best wishes from Mrs. Kimenthia Watson",
      "date": "2026-05-14",
      "title": "false"
    },
    {
      "id": "custom_6cb0b1f2-d366-47b0-8562-652b644782a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5",
      "name": " Frances Shelton",
      "text": "Michele was extremely kind and professional towards me as a new guest. She quickly responded to issues noted in my unit and had them promptly addressed. Always greeted with a warm and sincere smile.\n",
      "date": "2025-10-14",
      "title": "false"
    },
    {
      "id": "custom_121bf4aa-4506-4c67-8c8f-20f5776b15d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5",
      "name": " Live Big",
      "text": "Matt did a great job he focus on a solution and not the problem..Got the job done efficiently and I appreciate him for that!! Thank you Matt!!!\n",
      "date": "2026-08-08",
      "title": "false"
    },
    {
      "id": "custom_5efa1db1-0e9c-48af-b901-ccc08184c5e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5",
      "name": " Terri D Brown",
      "text": "Excellent care! Thank you Joshua Williams\n",
      "date": "2026-08-07",
      "title": "false"
    },
    {
      "id": "custom_88835efe-222d-415d-89d5-6642de25799c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5",
      "name": " Elandra Franklin",
      "text": "Incredibly awesome process. Move in was smooth. Josh made it happen in less than a week. and the leasing team is very inviting and friendly. Highly recommended.\n",
      "date": "2026-08-07",
      "title": "false"
    },
    {
      "id": "custom_633f2936-576b-466d-97a0-66a24bac3f03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "rating": "5",
      "name": "Weylin Bailey We",
      "text": "I love this place!!!!!\n",
      "date": "2026-06-14",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_61d6df93f769269b375d367d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5504-2836-7234-8fa1-cf5f14c8aac0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d5504-2836-7234-8fa1-cf5f14c8aac0",
        "storage_key": "property/6767906449167339/019d5504-2836-7234-8fa1-cf5f14c8aac0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=12xKndjLzwj"
    },
    {
      "id": "ec_b3ce8f15215285b80d392541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5504-2849-7773-85f7-b5c0d4822e84.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d5504-2849-7773-85f7-b5c0d4822e84",
        "storage_key": "property/6767906449167339/019d5504-2849-7773-85f7-b5c0d4822e84.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hPbAZvrmSat"
    },
    {
      "id": "ec_48cd1435637b8828aa659431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Discover the The Preston apartments with this immersive walkthrough virtual tour experience with LCP Media",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5504-2f7b-73ce-a5ac-5b308b72666b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d5504-2f7b-73ce-a5ac-5b308b72666b",
        "storage_key": "property/6767906449167339/019d5504-2f7b-73ce-a5ac-5b308b72666b.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Virtual Tour 3",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=5e8f4046d8caa91f0d7df083"
    },
    {
      "id": "ec_71f01463c96745a77b463c66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5504-281f-737e-80d5-be9df8ad90d9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d5504-281f-737e-80d5-be9df8ad90d9",
        "storage_key": "property/6767906449167339/019d5504-281f-737e-80d5-be9df8ad90d9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1062 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8i8bJmnYidr"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-d8a8-7149-ad19-1cbad6d765de",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Preston Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339"
    },
    {
      "lead_collector_id": "019db23f-d91e-77ae-9d4f-ac4fc1e01eb6",
      "lead_source": "FACEBOOK_ADS",
      "name": "The Preston Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339"
    },
    {
      "lead_collector_id": "019db23f-d994-7351-b2fd-12d34196c619",
      "lead_source": "LANDING_PAGE",
      "name": "The Preston Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-mcdonough-ga-preston",
      "search_query": "resort-style pool apartments mcdonough ga",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in McDonough, GA",
      "h2_subtitle": "Discover apartments in McDonough, GA with a resort-style pool. The Preston offers modern living with premier amenities including a refreshing pool.",
      "page_copy": "Welcome to The Preston, where every day feels like a vacation when you choose our resort-style pool apartments in McDonough, GA. Nestled in the tranquil surroundings of Outlying Henry County, these spacious one, two, and three-bedroom residences promise an unparalleled living experience. Dive into relaxation at our stunning resort-style pool or reach your fitness goals in our state-of-the-art gym. \n\nLiving at The Preston means enjoying the best of both worlds—modern, stylish apartments with serene balconies combined with exceptional amenities that cater to every lifestyle. Whether you're taking a dip in the pool or spending time at the playground, our community is crafted for those seeking comfort and convenience. Schedule a tour today to experience resort-style living right here in McDonough, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments McDonough, GA",
      "seo_description": "Experience resort-style pool living in McDonough, GA at The Preston. Modern amenities and comfortable spaces await. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-henry-county-preston",
      "search_query": "apartments with fitness center henry county",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Henry County",
      "h2_subtitle": "Enjoy the convenience of living in Henry County with apartments featuring a modern fitness center at The Preston.",
      "page_copy": "At The Preston in Henry County, discover the perfect balance of comfort and wellness with our apartments that include an exceptional fitness center. Located in McDonough, GA, our community is designed to support a healthy and active lifestyle. Residents can take advantage of our state-of-the-art gym, ideal for fitness enthusiasts who want to maintain their routines without leaving home.\n\nComplemented by spacious one, two, and three-bedroom floor plans, each apartment offers modern finishes and serene balconies. The Preston also provides additional amenities like a resort-style pool and a playground, making it a preferred choice for those seeking convenience and relaxation in one place. Learn more about how our fitness-centered apartments can elevate your lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Henry County",
      "seo_description": "Find apartments with a modern fitness center in Henry County, GA at The Preston. Enjoy comfort and convenience. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "modern-apartments-with-balcony-mcdonough-ga-preston",
      "search_query": "modern apartments with balcony mcdonough ga",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Balconies in McDonough, GA",
      "h2_subtitle": "Experience contemporary living in McDonough, GA with modern apartments featuring private balconies at The Preston.",
      "page_copy": "Discover the ultimate in modern living at The Preston, where our apartments with balconies in McDonough, GA offer a stylish retreat. Each one, two, and three-bedroom apartment is thoughtfully designed with contemporary finishes and private balconies, perfect for enjoying the serene surroundings of Outlying Henry County.\n\nThe Preston's focus on both comfort and style does not end within your apartment. Residents benefit from premier community amenities including a resort-style pool, playground, and a cutting-edge fitness center. Our homes are designed to fit a variety of lifestyles, ensuring that everything you need for a comfortable living experience is right at your fingertips. Make The Preston your new home and enjoy modern living features in McDonough, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Balconies McDonough, GA",
      "seo_description": "Explore modern apartments with private balconies in McDonough, GA at The Preston. Enjoy serene living with top amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "wood-style-flooring-apartments-30253-preston",
      "search_query": "wood-style flooring apartments 30253",
      "category": "Amenity",
      "h1_title": "Wood-Style Flooring Apartments in 30253",
      "h2_subtitle": "Step into elegance in McDonough 30253 with wood-style flooring apartments at The Preston, offering a fresh take on modern living.",
      "page_copy": "At The Preston, located in the heart of McDonough, GA with the zip code 30253, experience the charm and beauty of wood-style flooring in our spacious apartments. Whether you're looking for a one, two, or three-bedroom layout, each residence is meticulously crafted to offer modern finishes and sophisticated touches, including the allure of wood-style floors. These features enhance your living space by bringing warmth and elegance into every room.\n\nBeyond the interiors, The Preston offers a wealth of amenities tailored to a vibrant lifestyle, from a shimmering resort-style pool to a contemporary fitness center and peaceful community spaces. Our serene balconies and family-friendly playground add to the comfort and appeal of choosing a home with us. Join The Preston community and elevate your lifestyle with the elegance of wood-style flooring.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wood-Style Flooring Apartments 30253",
      "seo_description": "Find elegant wood-style flooring apartments in 30253 at The Preston. Enjoy modern amenities and stylish living. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "washer-dryer-in-unit-apartments-oakland-ga-preston",
      "search_query": "washer and dryer in unit apartments oakland ga",
      "category": "Amenity",
      "h1_title": "In-Unit Washer & Dryer Apartments in Oakland, GA",
      "h2_subtitle": "Convenience meets comfort in Oakland, GA with apartments featuring in-unit washers and dryers at The Preston.",
      "page_copy": "Located just a short drive from Oakland, GA, The Preston in McDonough offers luxurious living with the convenience of in-unit washers and dryers. As part of our commitment to providing a modern lifestyle, our spacious one, two, and three-bedroom apartments are equipped with these essential amenities, making laundry days less of a chore and more of a convenience.\n\nBesides the practicality of having a washer and dryer in your apartment, The Preston enhances your living experience with other premium amenities. Enjoy unwinding by our resort-style pool or staying fit in our state-of-the-art fitness center. The tranquil balconies and vibrant playground also add to the community's appeal. Discover how The Preston can redefine your living with our thoughtful amenities geared toward comfort and convenience near Oakland, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer & Dryer Apartments Oakland, GA",
      "seo_description": "Experience comfort with in-unit washer & dryer apartments near Oakland, GA at The Preston. Modern amenities await. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mcdonough-ga-preston",
      "search_query": "one bedroom apartments in McDonough GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in McDonough, GA",
      "h2_subtitle": "Find your ideal one bedroom apartment in McDonough, GA at The Preston, where comfort meets modern living.",
      "page_copy": "Welcome to The Preston, where our thoughtfully designed one bedroom apartments in McDonough, GA capture the perfect blend of style and comfort. Each unit features modern finishes and spacious layouts that cater to various lifestyles, ensuring a cozy and functional living environment. Enjoy the tranquility of private balconies which provide an inviting outdoor retreat.\n\nBeyond your apartment, The Preston offers an array of amenities including a resort-style pool and a state-of-the-art fitness center, perfect for maintaining an active lifestyle. Nestled in Outlying Henry County, our community fosters a welcoming atmosphere with additional features like a playground for family fun. Discover the one bedroom apartment that perfectly suits your needs at The Preston and embrace all that McDonough living has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments McDonough, GA",
      "seo_description": "Explore one bedroom apartments in McDonough, GA at The Preston. Modern designs, top amenities, perfect for your lifestyle. Tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-outlying-henry-county-preston",
      "search_query": "two bedroom apartments near Outlying Henry County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Outlying Henry County",
      "h2_subtitle": "Discover spacious two bedroom apartments near Outlying Henry County at The Preston, featuring modern designs.",
      "page_copy": "Embrace comfortable living at The Preston, where our two bedroom apartments near Outlying Henry County provide the ideal setting for families, roommates, or anyone seeking a bit more space. Each apartment is designed with modern finishes and comes with serene balconies, offering a perfect mix of style and function that caters to contemporary lifestyles.\n\nResidents at The Preston enjoy access to exceptional amenities like a resort-style pool perfect for relaxation and a fitness center equipped for all activity levels. Located in McDonough, GA, just minutes from Outlying Henry County, our community also includes a family-friendly playground and model homes to view, making it easy to envision your new life here. Experience spacious living at The Preston today, where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Outlying Henry County",
      "seo_description": "Find spacious two bedroom apartments near Outlying Henry County at The Preston. Modern living with top amenities awaits. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167339",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-henry-county-ga-preston",
      "search_query": "three bedroom apartments Henry County GA",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Henry County, GA",
      "h2_subtitle": "Explore spacious three bedroom apartments in Henry County, GA, at The Preston combining comfort and modern style.",
      "page_copy": "At The Preston in McDonough, GA, our three bedroom apartments are ideal for families or individuals needing extra space and flexibility in Henry County. Each apartment is thoughtfully designed with modern finishes and spacious interiors, perfect for creating a home that fits your lifestyle. The inviting balconies offer a peaceful outdoor escape, complementing the serene surroundings of our community.\n\nBeyond the apartment walls, The Preston offers a range of amenities designed for both relaxation and activity. Enjoy leisure time at our resort-style pool or stay active in the state-of-the-art fitness center. Our community also features a playground, making it perfect for families. Situated in the heart of Henry County, GA, The Preston invites you to experience convenient, upscale living. Visit us and see why our three bedroom apartments are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d5502-78e2-733f-b3f8-e4f96238ec34",
        "storage_key": "property/6767906449167339/019d5502-78e2-733f-b3f8-e4f96238ec34.webp",
        "width": 2880,
        "height": 1920
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Henry County, GA",
      "seo_description": "Discover three bedroom apartments in Henry County, GA at The Preston. Spacious floor plans and modern amenities await. Schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6150"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671056705"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NZ8PLXPZ"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "18856143644"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "a0d200e711eff0b8"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "658515628"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8xvr3z8lvjk"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "5b8595c45d6e800976d5"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a134823c-d0cb-11f0-a5a4-0b0f3364079d"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://apollostore.blob.core.windows.net/thepreston/uploads/assets/untitled-video-2.6c8dcc26.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a134823c-d0cb-11f0-a5a4-0b0f3364079d/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImtTclpYZ3l6ZG9xSkdqL3hMT1h2Vnc9PSIsInZhbHVlIjoiV216MXBibU1KOUZ1bXo5ejh1V05OZz09IiwibWFjIjoiNDAyYWVkMjAxMDUzNGQ3MGMxMWY3MDc2NDcxYjhlY2U1MTY2OTExNzFlZmU1MzAwYzNjYTBhNGIyNmM3YmMyMyJ9"
    }
  ],
  "custom_qb_id": "6150",
  "custom_repli_id": "11671056705",
  "custom_google_gtm_id": "GTM-NZ8PLXPZ",
  "custom_hubspot_company_id": "18856143644",
  "custom_knock_community_id": "a0d200e711eff0b8",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "658515628",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8xvr3z8lvjk",
  "custom_call_rail_account_hash": "5b8595c45d6e800976d5",
  "custom_eliseai_building_token": "a134823c-d0cb-11f0-a5a4-0b0f3364079d",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://apollostore.blob.core.windows.net/thepreston/uploads/assets/untitled-video-2.6c8dcc26.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a134823c-d0cb-11f0-a5a4-0b0f3364079d/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImtTclpYZ3l6ZG9xSkdqL3hMT1h2Vnc9PSIsInZhbHVlIjoiV216MXBibU1KOUZ1bXo5ejh1V05OZz09IiwibWFjIjoiNDAyYWVkMjAxMDUzNGQ3MGMxMWY3MDc2NDcxYjhlY2U1MTY2OTExNzFlZmU1MzAwYzNjYTBhNGIyNmM3YmMyMyJ9",
  "custom_audioeye_site_id": "f6df8574-3679-401f-a65f-83749e653b1b",
  "custom_audioeye_site_hash": "721924462172aa074c9c1097922b8e60"
};

export const generatedAt = '2026-10-01T17:22:54.886Z';
